import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule } from '@angular/forms';
import { isBlank, isData, setTableName, iconListOptions, iconStyleOptions, Quarteroptions, isPresent, Weekoptions, dateFormatTypeOptions } from 'src/app/utils/utils';
import { CommonService } from 'src/app/services/common-service/common.service';
import { forkJoin, Observable, Subject } from 'rxjs';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { API } from 'src/app/constants/api';
import { KEYS } from 'src/app/constants/keys';
import { WebcamImage, WebcamModule } from 'ngx-webcam';
import { WebcamUtil } from 'src/app/modules/webcam/util/webcam.util';
import { WebcamInitError } from 'src/app/modules/webcam/domain/webcam-init-error';
import { RoutePath } from 'src/app/constants/routerPath';
import { CommonModule, DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/services/loader-service/loader.service';
import { environment } from 'src/environments/environment';
import { SrcPath } from 'src/app/constants/srcPath';
import { ChangePasswordComponent } from 'src/app/components/modal/change-password/change-password.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Labels } from 'src/app/constants/labels';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { AuthService as MSAuthService } from 'src/app/auth.service';
import { findIana } from 'windows-iana';
import { toZonedTime } from 'date-fns-tz';
import { endOfWeek, startOfWeek } from 'date-fns';
import { GraphService } from 'src/app/graph.service';
import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { User } from 'src/app/user';
import { ViewMailboxComponent } from 'src/app/components/modal/view-mailbox/view-mailbox.component';
import { DashboardInventoryMasterComponent } from 'src/app/components/dashboard-controls/dashboard-inventory-master/dashboard-inventory-master.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ChartControlsComponent } from './chart-controls/chart-controls.component';
import { UserTimesheetStatusDashboardComponent } from './user-timesheet-status-dashboard/user-timesheet-status-dashboard.component';
import { DashboardNavbarComponent } from 'src/app/components/dashboard-navbar/dashboard-navbar.component';
import { DashboardColoredColumnComponent } from 'src/app/components/dashboard-controls/dashboard-colored-column/dashboard-colored-column.component';
import { BulletinComponent } from 'src/app/components/dashboard-controls/bulletin/bulletin.component';
import { TodaysEventComponent } from 'src/app/components/dashboard-controls/todays-event/todays-event.component';
import { AbsentEmployeeListComponent } from 'src/app/components/dashboard-controls/absent-employee-list/absent-employee-list.component';
import { ProfileDetailsComponent } from 'src/app/components/dashboard-controls/profile-details/profile-details.component';
import { DashboardTimesheetProjectHoursComponent } from 'src/app/components/dashboard-controls/dashboard-timesheet-project-hours/dashboard-timesheet-project-hours.component';
import { DashboardColoredColumnnewComponent } from 'src/app/components/dashboard-controls/dashboard-colored-columnnew/dashboard-colored-columnnew.component';
import { AbsentEmployeeListnewComponent } from 'src/app/components/dashboard-controls/absent-employee-listnew/absent-employee-listnew.component';
import { EventMailboxButtonsComponent } from 'src/app/components/dashboard-controls/event-mailbox-buttons/event-mailbox-buttons.component';
import { DashboardBirthdayAnniversaryComponent } from 'src/app/components/dashboard-controls/dashboard-birthday-anniversary/dashboard-birthday-anniversary.component';
import { DashboardEventNotificationComponent } from 'src/app/components/dashboard-controls/dashboard-event-notification/dashboard-event-notification.component';
import { DashboardProjcetDetailsComponent } from 'src/app/components/dashboard-controls/dashboard-projcet-details/dashboard-projcet-details.component';
import { BulletinnewComponent } from 'src/app/components/dashboard-controls/bulletinnew/bulletinnew.component';
import { DashboardToDoListnewComponent } from 'src/app/components/dashboard-controls/dashboard-to-do-listnew/dashboard-to-do-listnew.component';
import { DashboardContactStatusComponent } from 'src/app/components/dashboard-controls/dashboard-contact-status/dashboard-contact-status.component';
import { DashboardAssessmentCalenderComponent } from 'src/app/components/dashboard-controls/dashboard-assessment-calender/dashboard-assessment-calender.component';
import { DashboardAdmissionBlockComponent } from 'src/app/components/dashboard-controls/dashboard-admission-block/dashboard-admission-block.component';
import { DashboardAbsentEmployeeComponent } from 'src/app/components/dashboard-controls/dashboard-absent-employee/dashboard-absent-employee.component';
import { RecdashboardPipelineEfficencyDataComponent } from 'src/app/components/dashboard-controls/recdashboard-pipeline-efficency-data/recdashboard-pipeline-efficency-data.component';
import { RecdashboardNewhiringBysourceComponent } from 'src/app/components/dashboard-controls/recdashboard-newhiring-bysource/recdashboard-newhiring-bysource.component';
import { DashboardOpprunityRevenueclosedComponent } from 'src/app/components/dashboard-controls/dashboard-opprunity-revenueclosed/dashboard-opprunity-revenueclosed.component';
import { DashboardOpportunityStatusComponent } from 'src/app/components/dashboard-controls/dashboard-opportunity-status/dashboard-opportunity-status.component';
import { DashboardOpprunityCampaigntypeComponent } from 'src/app/components/dashboard-controls/dashboard-opprunity-campaigntype/dashboard-opprunity-campaigntype.component';
import { PgRecentBookingsComponent } from 'src/app/components/dashboard-controls/pg-recent-bookings/pg-recent-bookings.component';
import { PgRecentInquiriesComponent } from 'src/app/components/dashboard-controls/pg-recent-inquiries/pg-recent-inquiries.component';
import { RoomStatusSummaryComponent } from 'src/app/components/dashboard-controls/room-status-summary/room-status-summary.component';
import { PgLatestPaymentComponent } from 'src/app/components/dashboard-controls/pg-latest-payment/pg-latest-payment.component';
import { DashboardTodoListAltComponent } from 'src/app/components/dashboard-controls/dashboard-todo-listalt/dashboard-todo-list-altcomponent';
import { SessionTimerService } from 'src/app/services/session-timer.service';
import { FullscreenService } from 'src/app/services/fullscreen.service';
import { DashboardToDoListComponent } from 'src/app/components/dashboard-controls/dashboard-to-do-list/dashboard-to-do-list.component';

@Component({
  selector: 'app-dashboard-user',
  templateUrl: './dashboard-user.component.html',
  styleUrls: ['./dashboard-user.component.scss'],
  imports: [SharedModule, CommonModule, RouterModule,
    WebcamModule, FormsModule,
    DashboardColoredColumnComponent, BulletinComponent, TodaysEventComponent,
    AbsentEmployeeListComponent, DashboardTodoListAltComponent, ProfileDetailsComponent,
    DashboardTimesheetProjectHoursComponent, DashboardNavbarComponent,
    DashboardColoredColumnnewComponent, AbsentEmployeeListnewComponent, EventMailboxButtonsComponent,
    DashboardBirthdayAnniversaryComponent, ChartControlsComponent,
    DashboardEventNotificationComponent,
    DashboardProjcetDetailsComponent, BulletinnewComponent,
    DashboardContactStatusComponent,
    DashboardAssessmentCalenderComponent, DashboardInventoryMasterComponent, DashboardAdmissionBlockComponent,
    DashboardAbsentEmployeeComponent, RecdashboardPipelineEfficencyDataComponent, DashboardToDoListnewComponent,
    RecdashboardNewhiringBysourceComponent, DashboardOpprunityRevenueclosedComponent, DashboardOpportunityStatusComponent,
    DashboardOpprunityCampaigntypeComponent, PgRecentBookingsComponent, PgRecentInquiriesComponent,
    RoomStatusSummaryComponent, PgLatestPaymentComponent, DashboardToDoListComponent,
    UserTimesheetStatusDashboardComponent],
  standalone: true
})
export class DashboardUserComponent implements OnInit {
  dashboardTemplateForm!: FormGroup;
  chartForm1!: FormGroup;
  chartForm2!: FormGroup;
  chartForm3!: FormGroup;
  chartForm4!: FormGroup;
  chartForm5!: FormGroup;
  chartForm6!: FormGroup;
  chartFormcon!: FormGroup;
  routePath = RoutePath;
  menuId: any;
  graphData: any;
  month: any = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  tempCode: any;
  dealsProgress: any = [];
  dealsPivote: any = [];
  leadConversation: any = [];
  leadTiles: any = [];
  top5Deals: any = [];
  totalEmpCnt = '';
  roundChartEffHiring: any = [];
  totalEHValue = '';
  recruitmentFunnel: any = [];
  offerDecline: any = [];
  projectList: any = [];
  defaultProjectId = '0';
  cust_chartBlock1: any = [];
  projectListData: any = [];
  defaultEmpProjectId = '0';
  defaultEmpLeaveProjectId = '0';
  chartForm2ExpnseLength = 0;
  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public facingMode: string = 'environment';
  public errors: WebcamInitError[] = [];
  modalRef!: BsModalRef;
  labelChangePassword = Labels.changePassword;
  routerPath = RoutePath;
  // latest snapshot
  public webcamImage: WebcamImage | null = null;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  MeetingList: any = [];
  Opportunity: string = '';
  empasidebox: any = [];
  empasidebox1: any;
  empasidebox2: any;
  DealProgressColoredArray: any = ["bars", "bars blue", "bars pink", "bars green", "bars violet", "bars", "bars blue", "bars pink", "bars green", "bars violet"];
  dealsPivotecoloredArray: any = ["pink", "blue", "green", "blue2", "orange", "pink"]
  recuritmenthirecoloredArray: any = ["pink", "green", "blue", "yellow", "pink", "green", "blue", "yellow"]
  recuritmenthirbarecoloredArray: any = ["progresspinkbar", "progressgreenbar", "progressbluebar", "progressyellowbar", "progresspinkbar", "progressgreenbar", "progressbluebar", "progressyellowbar"]
  recuirtmentnewhire: any;
  top10Opportunity: any;
  top10wonOpportunity: any;
  recruirtmenttiles: any = [];
  isLogo: boolean = false;
  timesheetweek: any = 1;
  timeoutweek: any = 1;
  Weekoptiontype: any = Weekoptions;
  Contact = 'Contact';
  contactlist: any = [];
  MeetingListnew: any = [];
  MeetingList1!: any[];
  activemeeting: boolean = true;
  usertype: any = '';
  ismcf: boolean = false;
  isgusa: boolean = false;
  isVendor: boolean = false;
  srcPath = SrcPath;
  vendorName = '';
  vendorOpportunityList: any = [];
  vendorDocsList: any = [];
  calenderEvents: any = [];
  meetingList: any = [];
  Quarterdata: any = Quarteroptions;
  winRatioQuarterData: any = Quarteroptions;
  funnelquarter: any = 'Q1';
  winQuarter: any = 'Q1';
  funnelchart: any[] = [];
  winRatioChart: any[] = [];
  admissionlist!: any[];
  labelMessages = Labels.messages;

  groupmail!: { date: string; mails: any; }[];
  mainmails: any = [];
  mailDetails: any;
  public mails?: MicrosoftGraph.Message[] = [];
  mailDetailsContent: any;
  mailSubject: any;
  mailSender: any;
  mailReceiver!: string;
  mailDate!: any;
  tabPageId: any;
  filtercolumn!: any;
  showSearch!: string;
  currentTimeZone!: string;
  noToSkip = 0;
  loadCount = 0;
  bsModalRef!: BsModalRef;
  Occupancyglance: any;
  isNotLoading: any;
  isEmployeeMgmtDashboardProjectPresent!: boolean;
  ispgw: boolean = false;
  contactCount: any;
  customerCount: any;
  vendorCount: any;
  custVendorCount: any;
  scheduleMeetingColor: any = ['purple', 'green', 'yellow', 'orange', 'blue', 'pink', 'yellow', 'purple', 'green', 'yellow', 'orange', 'blue', 'pink', 'yellow']
  custDateFormat: any;
  custDateFormat_date: any;
  date_ForamatSaveTypeOption = dateFormatTypeOptions;
  stageTableData: any = [];
  lastLoginDate: any;
  accountCreatedDate: any;
  groupDataMeeting: any = [];
  stageSummaryMap: any = {};
  chartFormDonut!: FormGroup;
  chartFormLineTrend!: FormGroup;
  quarterRevenue: any = {};
  selectedRevenueQuarter = 'Q1';
  totalRevenue = 0;
  totalProposalApprovedCount = 0;
  chartFormRecOffer!: FormGroup;
  chartFormRecpipline!: FormGroup;
  activityDataRecruitment: any;
  weeklyNewSession: any = 0;
  avgTimeOnSiteWeek: any = 0;
  bounceRate: any = 0;
  buttonlabelAnnouce: string = 'Edit';
  buttonAnnouce: string = 'NoEdit';
  AnnounceText: any;
  viewPageCount: any = 0;
  @ViewChild('paraAnnounce') myannounce!: ElementRef;
  activityData: any;
  resources: any;
  get user(): User | any {
    return this.msAuthService.user;
  }
  // Is a user logged in?
  get authenticated(): boolean {
    return this.msAuthService.authenticated;
  }

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private loaderService: LoaderService,
    private graphService: GraphService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private commonService: CommonService, private datepipe: DatePipe,
    public modalService: BsModalService,
    private authService: AuthService,
    public msAuthService: MSAuthService, private sessionTimer: SessionTimerService,
    private loader: LoaderService, private fullscreenService: FullscreenService) {
    this.route.queryParams.subscribe(params => {
      this.defaultProjectId = params['dbu'];
      // if(params['funnelquarter']){
      // this.funnelquarter = params['funnelquarter'];  
      // this.commonService.ogLog('funnelquarter', this.funnelquarter);
      //  this.ngOnInit();
      // }
      if (params['winQuarter']) {
        this.winQuarter = params['winQuarter'];
        this.commonService.ogLog('winQuarter', this.winQuarter);
        this.ngOnInit();
      }
    });


  }


  public triggerSnapshot(): void {
    this.trigger.next();
  }


  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }


  public handleInitError(error: WebcamInitError): void {
    if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
      console.warn('Camera access was not allowed by user!');
    }
    this.errors.push(error);
  }


  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }


  public handleImage(webcamImage: WebcamImage): void {
    this.commonService.ogLog('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
    let dataurl = webcamImage.imageAsDataUrl;
    //'data:image/png;base64,R0lGODlhEAAQAMQAAORHHOVSKudfOulrSOp3WOyDZu6QdvCchPGolfO0o/XBs/fNwfjZ0frl3/zy7////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAkAABAALAAAAAAQABAAAAVVICSOZGlCQAosJ6mu7fiyZeKqNKToQGDsM8hBADgUXoGAiqhSvp5QAnQKGIgUhwFUYLCVDFCrKUE1lBavAViFIDlTImbKC5Gm2hB0SlBCBMQiB0UjIQA7';
    let filename = 'haha.png';
    let format = 'png';
    this.dataURLtoFile(dataurl, filename, format);
  }
  dataURLtoFile(dataurl: string, filename: string, format: string) {
    const arr: any = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    const curTime = (new Date().toLocaleDateString().replace("/", "")).replace("/", "") + new Date().getTime();
    const fname = 'haha';
    const extension = format;
    //fname.slice((Math.max(0, fname.lastIndexOf(".")) || Infinity) + 1);
    const filesaved = curTime + '.' + extension;
    let userID = '1';
    let fullpath = "uploadFiles/gstiusa/" + userID + "/" + filesaved;
    // fullpath = (((fullpath.replace("/", "~")).replace("/", "~")).replace("/", "~")).replace("/", "~");
    // userData.imgUrl = fullpath;
    // this.commonService.ogLog('errorstart',userData.imgFiles, curTime, userID)
    let files = new File([u8arr], filename, { type: format });
    // saveAs(new File([u8arr], filename, {type: format}));
    this.commonService.uploadManageUserProfile(files, curTime, userID).subscribe(data => {
      this.commonService.ogLog('uploadManageUserProfile : ', data);
    }, error => {
      console.log('Error!', error);
    });

  }

  public cameraWasSwitched(deviceId: string): void {
    this.commonService.ogLog('active device: ' + deviceId);
    this.deviceId = deviceId;
  }


  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }


  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }


  public get videoOptions(): MediaTrackConstraints {
    const result: MediaTrackConstraints = {};
    if (this.facingMode && this.facingMode !== '') {
      result.facingMode = { ideal: this.facingMode };
    }


    return result;
  }
  /** project load startr */
  getProjects() {

    this.projectList = [];
    this.commonService.ogLog('user id: ', this.commonService.getUserCredentials(KEYS.credential_account_id));
    let accountId = this.commonService.getUserCredentials(KEYS.credential_account_id);
    this.commonService.getProjects(accountId).subscribe((data: any) => {
      this.projectList = data['table'];
    });
  }
  onGroupEmplist_change(emp: any) {
    this.defaultProjectId = emp.target.value;
    this.commonService.setCustomerEmpDashboardProjectId(this.defaultProjectId);
    this.router.navigate([this.routePath.dashboardUser], { queryParams: { dbu: this.defaultProjectId } });
    // window.location.reload();

  }
  /** Project load end */

  ngOnInit(): void {
    this.loaderService.isLoading.subscribe(res => {
      this.isNotLoading = !res;
    });
    this.custDateFormat = (sessionStorage.getItem(KEYS.customerDateFormat)!);
    let existcheckDates = this.date_ForamatSaveTypeOption.filter((s: any) => s.name == this.custDateFormat)[0];
    if (isPresent(existcheckDates)) {
      this.custDateFormat_date = this.date_ForamatSaveTypeOption.filter((s: any) => s.name == this.custDateFormat)[0].id.toString();
    }
    const userdetails = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    this.vendorName = userdetails.gstibo_account_firstname;// + ' ' +
    //userdetails.gstibo_account_middlename + ' ' + userdetails.gstibo_account_lastname
    this.isVendor = userdetails.user_Type_Name.toLowerCase() == 'vendor' ? true : false;
    this.commonService.ogLog('userdetails.user_Type_Name.toLowerCase():', userdetails.user_Type_Name.toLowerCase());
    this.commonService.ogLog('this.isVendor:', this.isVendor)
    if (this.commonService.getUserCredentials(KEYS.credential_site_value) == 'MCF') {
      this.ismcf = true;
    }
    if (this.commonService.getUserCredentials(KEYS.credential_site_value) == 'Gusa') {
      this.isgusa = true;
    }
    if (this.commonService.getUserCredentials(KEYS.credential_site_value).toLowerCase() == 'pgw') {
      this.ispgw = true;
    }
    if (this.commonService.getUserCredentials(KEYS.credential_site_value).toLowerCase() == 'jusa') {
      let fromPagePageDetails = JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!);
      this.router.navigate([RoutePath.userPageLayout, fromPagePageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(fromPagePageDetails) } });
    }
    let accountUser = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    this.usertype = accountUser.user_Type_Name;
    this.Opportunity = 'Opportunity';
    this.refreshTableData();
    this.loadMeetingdetails();
    this.loadProjects();
    if (this.commonService.getUserCredentials(KEYS.credential_site_value).toLowerCase() == 'pgw') {
      this.loadOccupancy();
    }
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
    let dashboard_id;
    let details: any;
    let dashboarddefult_data = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    if (this.isVendor == true) {
      dashboard_id = environment.dashboardId;
      details = {
        gstibo_dashboard_id: dashboard_id,
        gstibo_template_id: 1,
        gstibo_module_id: 1
      }
    }
    else {
      if (isBlank(dashboarddefult_data.gstibo_dashboard_id)) {
        dashboard_id = environment.dashboardId;
        details = {
          gstibo_dashboard_id: dashboard_id,
          gstibo_template_id: 1,
          gstibo_module_id: 1
        }
      }
      else {
        dashboard_id = dashboarddefult_data.gstibo_dashboard_id;
        details = {
          gstibo_dashboard_id: dashboard_id,
          gstibo_template_id: 1,
          gstibo_module_id: 1
        }
      }
    }

    this.commonService.ogLog('data getProjectsid:1 ', this.defaultProjectId);
    this.commonService.ogLog('data getProjectsid:11 ', this.commonService.getCustomerEmpDashboardProjectId(), this.commonService.getEmpDashboardProjectId());

    if (isPresent(this.commonService.getCustomerEmpDashboardProjectId())) {
      this.defaultProjectId = this.commonService.getCustomerEmpDashboardProjectId();
      this.commonService.setCustomerEmpDashboardProjectId(this.defaultProjectId);
      this.commonService.ogLog('data getProjectsid:2 ', this.defaultProjectId);
    }
    else if (isPresent(this.commonService.getUserCredentials("gstibo_default_project"))) {
      this.defaultProjectId = (isPresent(this.commonService.getUserCredentials("gstibo_default_project")) ? this.commonService.getUserCredentials("gstibo_default_project") : [null]);
      this.commonService.setCustomerEmpDashboardProjectId(this.defaultProjectId);
      //this.commonService.getCustomerEmpDashboardProjectId();
    }
    if (isPresent(this.commonService.getEmpDashboardProjectId())) {
      this.defaultEmpProjectId = this.commonService.getEmpDashboardProjectId();
      this.commonService.setEmpDashboardProjectId(this.defaultEmpProjectId);
    }
    else {
      this.defaultEmpProjectId = '0';
    }
    if (isPresent(this.commonService.getEmpLeaveDashboardProjectId())) {
      this.defaultEmpLeaveProjectId = this.commonService.getEmpLeaveDashboardProjectId();
      this.commonService.setEmpLeaveDashboardProjectId(this.defaultEmpLeaveProjectId);
    }
    else {
      this.defaultEmpLeaveProjectId = '0';
    }
    this.getProjects();
    this.getAnnounceData();
    this.getActivityDetails();
    this.route.queryParams.subscribe(params => {
      if (isPresent(params['menuid']) && (params['menuid'].length > 0)) {
        this.menuId = params['menuid'];
        let accountUser = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
        if (!isBlank(accountUser)) {
          this.commonService.ogLog('this.menuId, accountUser.user_Type:', this.menuId, accountUser.user_Type)
          this.commonService.getDashboardDetailsWithModuleId(this.menuId, accountUser.user_Type).subscribe((data: any) => {
            this.commonService.ogLog("Data :", data);
            let dataRow;
            if (data['table'].length > 1) {
              if (accountUser.user_Type == 5)
                dataRow = data['table'][1];
              else
                dataRow = data['table'][0];
            }
            else {
              dataRow = data['table'][0];
            }
            if (isData(data)) {
              details = {
                gstibo_dashboard_id: dataRow['gstibo_dashboard_id'],
                gstibo_template_id: dataRow['gstibo_template_id'],
                gstibo_module_id: dataRow['gstibo_module_id']
              }
              this.initPageForm(details);
            }
            else {
              this.initPageForm(details);
            }
            this.getAnnounceData();
            this.getActivityDetails();
          });
        }

      }
      else {
        this.menuId = dashboard_id;
        let accountUser = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
        this.commonService.getDashboardDetailsWithModuleId(this.menuId, accountUser.user_Type).subscribe((data: any) => {
          this.commonService.ogLog("Data :", data);
          let dataRow;
          if (data['table'].length > 1) {
            if (accountUser.user_Type == 5)
              dataRow = data['table'][1];
            else
              dataRow = data['table'][0];
          }
          else {
            dataRow = data['table'][0];
          }
          if (isData(data)) {
            details = {
              gstibo_dashboard_id: dataRow['gstibo_dashboard_id'],
              gstibo_template_id: dataRow['gstibo_template_id'],
              gstibo_module_id: dataRow['gstibo_module_id']
            }
            this.initPageForm(details);
          }
        });
      }
    });
    this.loadGraphTableData();
    if (isPresent(accountUser.lastlogindate)) {
      this.lastLoginDate = this.datePipe.transform(accountUser.lastlogindate, this.custDateFormat_date);
      this.accountCreatedDate = this.datePipe.transform(accountUser.gstibo_account_created_date, this.custDateFormat_date);
    }
  }
  refreshTableData() {
    this.commonService.refreshDBoard('').subscribe(data => { });
  }
  initPageForm(details: any) {
    this.dashboardTemplateForm = this.formBuilder.group({
      dashboardId: details['gstibo_dashboard_id'],
      templateId: [details['gstibo_template_id'], Validators.required],
      moduleId: [details['gstibo_module_id'], Validators.required],
      chartBlock1: null,
      chartBlock2: null,
      chartBlock3: null,
      chartBlock1Title: null,
      chartBlock2Title: null,
      chartBlock3Title: null,
      crmCB1: null,
      crmCB2: null,
      crmCB3: null,
      crmCB4: null,
      crmCB5: null,
      crmCB6: null,
      crmCB1Title: null,
      crmCB2Title: null,
      crmCB3Title: null,
      crmCB4Title: null,
      crmCB5Title: null,
      crmCB6Title: null,
      SB1Title: null,
      chartBlock4: null,
      chartBlock5: null,
      chartBlock6: null,
      chartBlock7: null,
      chartBlock4Title: null,
      chartBlock5Title: null,
      chartBlock6Title: null,
      chartBlock7Title: null,
      customerCB1Title: null,
      customerCB2Title: null,
      customerCB3Title: null,
      emp_asideblock1: null,
      emp_asideblock1Title: null,
      emp_asideblock2: null,
      emp_asideblock2Title: null

    });
    this.getDashboardTemplateCode(details['gstibo_dashboard_id']);
    this.commonService.ogLog('tempCode:', this.tempCode);
  }
  getDashboardTemplateCode(dashboardId: string) {
    let accountUser = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    // accountUser.user_Type
    this.commonService.getDashboardTemplateCode('', dashboardId).subscribe((data: any) => {
      if (isData(data)) {
        this.tempCode = data['table'][0]['gstibo_template_code'];
        this.commonService.ogLog('tempCode:', this.tempCode);
        switch (this.tempCode) {
          case 'T1':
            if (accountUser.user_Type == 5) { // customer type
              this.tempCode = 'T4';
              this.loadTemplateOneCustomer(dashboardId);
            }
            else {
              this.loadTemplateOne(dashboardId);
            }
            break;
          case 'T2':
            this.loadTemplateTwo(dashboardId);
            break;
          case 'T3':
            this.loadTemplateThree(dashboardId);
            break;
          case 'T4':
            this.loadTemplateOneCustomer(dashboardId);
            break;
          case 'T5':
            this.loadTemplatefive(dashboardId);
            break;
          case 'T6':
            this.loadTemplatesix(dashboardId);
            //this.loadTemplatesten(dashboardId);
            break;
          case 'T7':
            this.loadTemplateseven(dashboardId);
            break;
          case 'T8':
            this.loadTemplateeight(dashboardId);
            break;
          case 'T10':
            this.loadTemplatesten(dashboardId);
            break;
          case 'T11':
            this.loadTemplateseleven(dashboardId);
            break;
          case 'T12':
            if (this.ismcf == true) {
              this.loadTemplateeighteen(dashboardId);
            }
            else {
              this.loadTemplatetwelve(dashboardId);
            }
            break;
          case 'T13':
            this.loadTemplatethirteen(dashboardId);
            break;
          case 'T14':
            this.loadTemplatefourteen(dashboardId);
            break;
          case 'T15':
            this.loadTemplatefifteen(dashboardId);
            break;
          case 'T16':
            this.loadTemplateSIXTEEN(dashboardId);
            break;
          case 'T17':
            this.loadTemplateSEVENTEEN(dashboardId);
            break;
          case 'T19':
            if (this.ispgw == true) { this.loadTemplatenineteen(dashboardId); }
            break;
          case 'T20':
            this.loadTemplateTwenty()
            break;
          case 'T21':
            this.loadTemplateTwentyOne();
            if (this.ismcf == true) {
              this.loadTemplateeighteen(dashboardId);
            }
            else {
              this.loadTemplatetwelve(dashboardId);
            }
            break;
          case 'T22':
            this.loadTemplatefifteen(dashboardId);
            break;
          case 'T23':
            this.loadTemplateTwentyThree()
            break;
        }
      }
    }, error => {
      console.log('getDashboardTemplateCode error');
    })
  }
  loadTemplateOne(dashboardId: string) {
    let chartColumns1 = [];
    let chartColumns2 = [];
    let chartColumns3: string[] = [];
    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId);
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : '')
      });
      this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm)
      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_ProjectsTracked");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_EmployeeComposition");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_LeaveComposition");

      forkJoin([chartQuery1, chartQuery2, chartQuery3]).subscribe((qdata: any) => {
        
        let chData1 = [];
        let chData2 = [];
        let chData3 = [];
        //console.log('qdata : ', qdata);
        if ((qdata[0]['table']) && (qdata[0]['table'].length > 0)) {
          
          let myData = [];
          chartColumns1 = ['Month', 'Hours'];
          //console.log('myData:', myData);
          //console.log('qdata[0]', qdata[0]['table']);
          if (this.defaultEmpProjectId == '0') {
            let myMap = new Map();
            let allData = [];
            qdata[0]['table'].forEach((element1: any) => {
              if (myMap.has(this.month[element1.gstibo_Month])) {
                let monVal = 0;
                monVal = myMap.get(this.month[element1.gstibo_Month])
                myMap.set(this.month[element1.gstibo_Month], element1.gstibo_NoOfProjects + monVal)
              } else {
                myMap.set(this.month[element1.gstibo_Month], element1.gstibo_NoOfProjects);
              }
            })

            this.commonService.ogLog(myMap, "myMap...................")
            allData = Array.from(myMap)
            this.commonService.ogLog(allData, "allData                                                                                      ........")

            chData1 = allData;
          } else {
            const empPrjId = (qdata[0]['table']).filter((x: any) => x.gstibo_Projectid == this.defaultEmpProjectId);
            if (isPresent(empPrjId)) {
              empPrjId.forEach((element1: any) => {
                let chSubData1 = [];
                chSubData1.push(this.month[element1['gstibo_Month']]);
                chSubData1.push(element1['gstibo_NoOfProjects']);
                chData1.push(chSubData1);
              });
            } else {
              let chSubData1 = [];
              chartColumns1 = ['Month', 'Hours'];
              chSubData1.push(this.month[1]);
              chSubData1.push(0);
              chData1.push(chSubData1);
            }

          }
          //console.log('chData1:', chData1);
          //console.log('data1:', qdata[0]['table']);
        } else {
          let myData = [];
          chartColumns1 = ['Month', 'Hours'];
          // console.log('myData:', myData);
          // qdata[0]['table'].forEach(element1 => {
          let chSubData1 = [];
          chSubData1.push(this.month[1]);
          chSubData1.push(0);
          chData1.push(chSubData1);
          // });
          // chData1 = null;
        }
        this.chartForm1.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock1,
          width: '100%',
          height: '25rem',
          data: chData1,
          columnNames: chartColumns1
        });
        if ((qdata[1]['table']) && (qdata[1]['table'].length > 0)) {
          let chSubData2 = [];
          chartColumns2 = ['Men', 'Women']
          chSubData2.push('Men');
          chSubData2.push(qdata[1]['table'][0]['gstibo_Men']);
          chData2.push(chSubData2);
          chSubData2 = [];
          chSubData2.push('Women');
          chSubData2.push(qdata[1]['table'][0]['gstibo_Women']);
          chData2.push(chSubData2);
          let total = 0;
          chData2.forEach(element2 => {
            total += Number(element2[1]);
          });
          this.totalEmpCnt = total.toString();
        } else {
          let chSubData2 = [];
          chartColumns2 = ['Men', 'Women']
          chSubData2.push('Men');
          chSubData2.push(0);
          chData2.push(chSubData2);
          chSubData2 = [];
          chSubData2.push('Women');
          chSubData2.push(0);
          chData2.push(chSubData2);
          this.totalEmpCnt = '0';
          //chData2 = null;
        }
        this.chartForm2.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock2,
          width: '100%',
          height: '25rem',
          data: chData2,
          columnNames: chartColumns2
        });
        if ((qdata[2]['table']) && (qdata[2]['table'].length > 0)) {
          
          //console.log('data3:', qdata[2]['table']);
          if (this.defaultEmpLeaveProjectId == '0') {
            let myMap = new Map();
            let allData: any[] = [];
            let MainData: any[] = [];
            qdata[2]['table'].forEach((element3: any) => {
              if (myMap.has(this.month[element3.gstibo_Month])) {
                let myNewMap = new Map();
                myNewMap = myMap.get(this.month[element3.gstibo_Month]);
                myNewMap.set("casual", element3['gstibo_Casual'] + myNewMap.get("casual"));
                myNewMap.set("sick", element3['gstibo_Sick'] + myNewMap.get("sick"));
                myNewMap.set("holiday", element3['gstibo_Holiday'] + myNewMap.get("holiday"));

                myMap.set(this.month[element3.gstibo_Month], myNewMap);
              } else {
                let myNewMap = new Map();
                myNewMap.set("casual", element3['gstibo_Casual']);
                myNewMap.set("sick", element3['gstibo_Sick']);
                myNewMap.set("holiday", element3['gstibo_Holiday'])
                myMap.set(this.month[element3.gstibo_Month], myNewMap);
              }
            })
            MainData = Array.from(myMap);
            MainData.forEach(map => {
              let innerMap: any = Array.from(map[1]);
              let innerData = [];
              innerData.push(map[0]);
              innerData.push(innerMap[0][1]);
              innerData.push(innerMap[1][1]);
              innerData.push(innerMap[2][1]);
              allData.push(innerData);
              // allData = ['Oct', 1, 1, 1];
            });
            //console.log(allData, "allData...................")
            chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
            chData3 = allData;
            //console.log(chData3, "chData3default0...................")

          }
          else {
            const empLeavePrjId = (qdata[2]['table']).filter((x: any) => x.gstibo_Projectid == this.defaultEmpLeaveProjectId);
            if (isPresent(empLeavePrjId)) {
              empLeavePrjId.forEach((element3: any) => {
                let chSubData3 = [];
                chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
                chSubData3.push(this.month[element3['gstibo_Month']]);
                chSubData3.push(element3['gstibo_Casual']);
                chSubData3.push(element3['gstibo_Sick']);
                chSubData3.push(element3['gstibo_Holiday']);
                chData3.push(chSubData3);
              });
            } else {
              let chSubData3 = [];
              chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
              chSubData3.push(this.month[1]);
              chSubData3.push(0);
              chSubData3.push(0);
              chSubData3.push(0);
              chData3.push(chSubData3);
            }
            //console.log(chData3, "chData3InprjId...................")
          }

        } else {
          // qdata[2]['table'].forEach(element3 => {
          let chSubData3 = [];
          chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
          chSubData3.push(this.month[1]);
          chSubData3.push(0);
          chSubData3.push(0);
          chSubData3.push(0);
          chData3.push(chSubData3);
          // });
          //chData3 = null;
        }
        this.chartForm3.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock3,
          width: '100%',
          height: '20rem',
          data: chData3,
          columnNames: chartColumns3
        });

      }, error => {
        console.log('forkjoin error');
      });

    });

    this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);
  }

  loadGraphTableData() {
    this.commonService.getDataFromTable(API.dashboardStaticTables.dashboard_emp_chart_count).subscribe((data: any) => {
      if (isData(data)) {
        this.graphData = data['table'];
      }
    });
  }
  loadTemplateTwo(dashboardId: string) {
    let chartColumns1: any[] = [];
    let chartColumns2: any[] = [];
    let chartColumns3: any[] = [];
    let chartColumns4: any[] = [];
    let chartColumns5: any[] = [];
    let chartColumns6: any[] = [];
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm4 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [],
      columnNames: [null],
      height: ''
    });
    this.chartForm5 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [],
      columnNames: [null],
      height: ''
    });
    this.chartForm6 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [],
      columnNames: [null],
      height: ''
    });
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        crmCB1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1'))[0]['gstibo_chart_type'] : ''),
        crmCB2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2'))[0]['gstibo_chart_type'] : ''),
        crmCB3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3'))[0]['gstibo_chart_type'] : ''),
        crmCB4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4'))[0]['gstibo_chart_type'] : ''),
        crmCB5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5'))[0]['gstibo_chart_type'] : ''),
        crmCB6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crmChartBlock6'))[0]['gstiboChartType'] : ''),
        crmCB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        crmCB2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        crmCB3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        crmCB4Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        crmCB5Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        crmCB6Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crmChartBlock6'))[0]['gstiboChartHeading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_staticBlock1'))[0]['gstiboChartHeading'] : '')
      });
      this.commonService.ogLog('dashboardTemplateForm : ', this.dashboardTemplateForm);
      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_DealsProgressByCount order by tbl_id asc");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_CountOfLeads");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_Deals");
      const chartQuery4 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_LeadConversationAnalytics");
      const chartQuery5 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_TotalValueConverted");
      const chartQuery6 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_BudgetVsActual");
      const chartQuery7 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_Tiles order by gstibo_id asc");
      const chartQuery8 = this.commonService.executedynamicquery("select Top 5* from gstibo_dev_Dboard_CRM_Top_Items order by gstibo_id asc");
      forkJoin(
        [
          chartQuery1, chartQuery2, chartQuery3,
          chartQuery4, chartQuery5, chartQuery6,
          chartQuery7, chartQuery8
        ]
      ).subscribe((qdata: any[]) => {
        let chData1 = [];
        let chData2 = [];
        let chData3 = [];
        let chData4 = [];
        let chData5 = [];
        let chData6: any[] = [];
        this.commonService.ogLog('qdata : ', qdata);
        if (qdata[0]['table']) {
          this.dealsProgress = qdata[0]['table'];
        }
        if ((qdata[1]['table']) && qdata[1]['table'].length > 0) {
          let value1 = [];
          let value2 = [];
          let value3 = [];
          value1.push('Leads Created');
          value2.push('Proposal Made');
          value3.push('Closed the deal');
          chartColumns2.push('Items');
          qdata[1]['table'].forEach((element3: any) => {
            value1.push(element3['gstibo_Value1']);
            value2.push(element3['gstibo_Value2']);
            value3.push(element3['gstibo_Value3']);
            chartColumns2.push(element3['gstibo_item']);
          });
          chData2.push(value1, value2, value3);
          this.commonService.ogLog('chData2 : ', chData2);
          this.chartForm2.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB2,
            //width: '100%',
            height: '20rem',
            data: chData2,
            columnNames: chartColumns2
          });
          this.commonService.ogLog('chartForm2 : ', this.chartForm2);
        }
        else {
          let value1 = [];
          let value2 = [];
          let value3 = [];
          value1.push('Leads Created');
          value2.push('Proposal Made');
          value3.push('Closed the deal');
          chartColumns2.push('Items');
          value1.push(0);
          value2.push(0);
          value3.push(0);
          chartColumns2.push('');
          chData2.push(value1, value2, value3);
          this.chartForm2.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB2,
            //width: '100%',
            height: '23rem',
            data: chData2,
            columnNames: chartColumns2
          });
          this.commonService.ogLog('chartForm2 : ', this.chartForm2);
        }
        if (qdata[2]['table']) {
          this.dealsPivote = qdata[2]['table'];
        }
        if (qdata[3]['table']) {
          this.leadConversation = qdata[3]['table'];
          this.commonService.ogLog('this.leadConversation', this.leadConversation);
        } else {
          const leadSample = [{
            gstibo_created_value: 0,
            gstibo_converted_value: 0,
            gstibo_won_value: 0,
            gstibo_lost_value: 0,
            gstibo_created_per: 0,
            gstibo_converted_per: 0,
            gstibo_won_per: 0,
            gstibo_lost_per: 0
          }];
          this.leadConversation = leadSample;
        }
        if ((qdata[4]['table']) && qdata[4]['table'].length > 0) {
          chartColumns5 = ['Month', 'Casual', 'Sick', 'Holiday'];
          const val = qdata[4]['table'][0]['gstibo_value'];
          const gaugeData = [
            ['Value', val]
          ];
          this.chartForm5.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB5,
            width: '100%',
            height: '23rem',
            data: gaugeData,
            columnNames: chartColumns5
          });
          this.commonService.ogLog('chartForm5 : ', this.chartForm5);
        }
        if ((qdata[5]['table']) && (qdata[5]['table'].length > 0)) {
          qdata[5]['table'].forEach((element3: any) => {
            let chSubData6 = [];
            chartColumns6 = ['Year', 'Budget', 'Actual'];
            chSubData6.push(element3['gstibo_year']);
            chSubData6.push(element3['gstibo_budget']);
            chSubData6.push(element3['gstibo_Actual']);
            chData6.push(chSubData6);
          });
          this.chartForm6.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB6,
            width: '100%',
            height: '23rem',
            data: chData6,
            columnNames: chartColumns6
          });
          this.commonService.ogLog('chartForm6 : ', this.chartForm6);
        }
        else {
          let chSubData6 = [];
          chartColumns6 = ['Year', 'Budget', 'Actual'];
          chSubData6.push('');
          chSubData6.push(0);
          chSubData6.push(0);
          chData6.push(chSubData6);
          this.chartForm6.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB6,
            width: '100%',
            height: '23rem',
            data: chData6,
            columnNames: chartColumns6
          });
        }
        if (qdata[6]['table']) {
          this.leadTiles = qdata[6]['table'];
        }
        if (qdata[7]['table']) {
          this.top5Deals = qdata[7]['table'];
          this.commonService.ogLog('top5Deals', this.top5Deals)
        }
      }, error => {
        console.log('forkjoin error');
      });
    }, error => {
      console.log('forkjoin error');
    });
  }
  loadTemplateThree(dashboardId: string) {
    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      legendPosition: 'bottom'
    });
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm4 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm5 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm6 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId);
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock7: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock4Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        chartBlock5Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        chartBlock6Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_heading'] : ''),
        chartBlock7Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_heading'] : '')
      });
      this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm)
      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_OpenReqByDepartment");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_EfficiencyOfHiring order by gstibo_id asc");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_Recruitment order by gstibo_value desc");
      const chartQuery4 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_Turnover");
      const chartQuery5 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_HiresBySource");
      const chartQuery6 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_HireByGrade");
      const chartQuery7 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_OfferDecline  order by gstibo_item");

      forkJoin([chartQuery1, chartQuery2, chartQuery3, chartQuery4, chartQuery5, chartQuery6, chartQuery7]).subscribe((qdata: any[]) => {
        let chData1: any[] = [];
        let chData2: any[] = [];
        let chData3: any[] = [];
        let chData4: any = [];
        let chData5: any[] = [];
        let chData6: any[] = [];
        let chData7: any[] = [];
        let chart1Columns: any[] = [];
        let chart5Columns: any[] = [];
        let chart6Columns: any[] = [];
        this.commonService.ogLog('qdata : ', qdata);
        if ((qdata[0]['table']) && (qdata[0]['table'].length > 0)) {
          qdata[0]['table'].forEach((element1: any) => {
            let chSubData1 = [];
            chart1Columns.push(element1.gstibo_dept);
            chSubData1.push(element1.gstibo_dept);
            chSubData1.push(element1.gstibo_value);
            chData1.push(chSubData1);
          });
          this.commonService.ogLog('chData1:', chData1);
          this.commonService.ogLog('data1:', qdata[0]['table']);
        } else {
          // qdata[0]['table'].forEach(element1 => {
          let chSubData1 = [];
          chart1Columns.push('0');
          chSubData1.push('0');
          chSubData1.push('0');
          chData1.push(chSubData1);
          // });
          //chData1 = null;
        }
        this.chartForm1.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock1,
          width: '100%',
          height: '25rem',
          data: chData1,
          columnNames: chart1Columns,
          legendPosition: 'bottom',
          bar: "35%",//requisition 
          bargroupwidth: '2',
        });
        if (qdata[1]['table']) {
          this.roundChartEffHiring = qdata[1]['table'];
          let total = 0;
          qdata[1]['table'].forEach((element2: any) => {
            total += Number(element2.gstibo_value);
          });
          this.totalEHValue = total.toString();
        }
        if (qdata[2]['table']) {
          this.commonService.ogLog('data3:', qdata[2]['table']);
          this.recruitmentFunnel = qdata[2]['table'];
        }
        if (qdata[3]['table']) {
          qdata[3]['table'].forEach((element1: any) => {
            let chSubData4 = [];
            chSubData4.push(element1.gstibo_year);
            chSubData4.push(element1.gstibo_value1);
            chSubData4.push(element1.gstibo_value1);
            chSubData4.push(element1.gstibo_value1);
            chData4.push(chSubData4);
          });
          this.commonService.ogLog('chData4:', chData4);
        } else {
          chData4 = null;
        }
        this.chartForm4.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock4,
          width: '100%',
          height: '25rem',
          data: chData4,
          columnNames: ['Year', 'Value1', 'Value2', 'Value3']
        });
        this.commonService.ogLog('qdata[4]:', qdata[4]['table']);
        if ((qdata[4]['table']) && (qdata[4]['table'].length > 0)) {
          qdata[4]['table'].forEach((element1: any) => {
            let chSubData5 = [];
            chart5Columns.push(element1.gstibo_Item);
            chSubData5.push(element1.gstibo_Item);
            chSubData5.push(element1.gstibo_value);
            chData5.push(chSubData5);
          });
          this.commonService.ogLog('chData5:', chData5);
          this.commonService.ogLog('data5:', qdata[4]['table']);
        } else {
          let chSubData5 = [];
          chart5Columns.push('0');
          chSubData5.push('0');
          chSubData5.push('0');
          chData5.push(chSubData5);
          //chData5 = null;
        }
        this.commonService.ogLog('chData5', chData5);
        this.chartForm5.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock5,
          width: '100%',
          height: '25rem',
          data: chData5,
          columnNames: chart5Columns,
          legendPosition: 'bottom'
        });
        if ((qdata[5]['table']) && (qdata[5]['table'].length > 0)) {
          qdata[5]['table'].forEach((element1: any) => {
            let chSubData6 = [];
            chSubData6.push(element1.gstibo_item);
            chSubData6.push(element1.gstibo_value);
            chData6.push(chSubData6);
          });

        } else {
          let chSubData6 = [];
          chSubData6.push('0');
          chSubData6.push(0);
          chData6.push(chSubData6);
          //chData6 = null;
        }
        this.chartForm6.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock6,
          width: '100%',
          height: '25rem',
          data: chData6,//bygrades
          columnNames: ['Item', 'Value']
        });
        if (qdata[6]['table']) {
          this.offerDecline = qdata[6]['table'];
          this.commonService.ogLog('chData7:', qdata[6]['table']);
        }
      }, error => {
        console.log('forkjoin error');
      });

    });

    this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);

  }

  loadTemplateOneCustomer(dashboardId: string) {
    
    let chartColumns1 = [];
    let chartColumns2: any = [];
    let chartColumns3: any = [];
    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      chartclick: ''
    });
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      chartclick: ''
    });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId);
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_staticBlock1'))[0]['gstibo_chart_heading'] : '')
      });
      this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm)
      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_cust_ProjectsTracked");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_cust_ProjectExpense");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_cust_ProjectsTracked_linechart");
      // const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_LeaveComposition");

      forkJoin([chartQuery1, chartQuery2, chartQuery3]).subscribe((qdata: any) => {
        let chData1 = [];
        let chData2 = [];
        let chData3 = [];
        this.chartForm2ExpnseLength = 0;
        this.cust_chartBlock1 = [];
        this.commonService.ogLog('qdata : ', qdata);
        if ((qdata[0]['table']) && (qdata[0]['table'].length > 0) && this.projectList.length > 0) {
          let myData: any = [];
          chartColumns1 = ['Month', 'Hours'];
          this.commonService.ogLog('myData:', myData);
          this.cust_chartBlock1 = qdata[0]['table'];
          const tbl1 = (qdata[0]['table']).filter((x: any) => x.gstibo_Projectid == this.defaultProjectId);
          if (isPresent(tbl1)) {
            tbl1.forEach((element1: any) => {
              let chSubData1 = [];
              chSubData1.push(this.month[element1['gstibo_Month']]);
              chSubData1.push(element1['gstibo_NoOfProjects']);
              chData1.push(chSubData1);
            });
          }
          else {
            chartColumns1 = ['Month', 'Hours'];
            let chSubData1 = [];
            chSubData1.push(this.month[1]);
            chSubData1.push(0);
            chData1.push(chSubData1);
          }
          // this.commonService.ogLog('chData1:', chData1);
          // this.commonService.ogLog('data1:', qdata[0]['table']);
        } else {
          let myData: any = [];
          chartColumns1 = ['Month', 'Hours'];
          this.commonService.ogLog('myData:', myData);
          // qdata[0]['table'].forEach(element1 => {
          let chSubData1 = [];
          chSubData1.push(this.month[1]);
          chSubData1.push(0);
          chData1.push(chSubData1);
          // });
          // chData1 = null;
        }
        this.chartForm1.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock1,
          width: '100%',
          height: '25rem',
          data: chData1,
          columnNames: chartColumns1,
          chartclick: 'true'
        });
        if ((qdata[1]['table']) && (qdata[1]['table'].length > 0) && this.projectList.length > 0) {
          let projData = this.projectList.filter((g: any) => g.gstibo_project_id == this.defaultProjectId);
          let projName = '';
          if (projData) {
            projName = projData[0]['gstibo_project_name'];
          }
          const tbl2 = (qdata[1]['table']).filter((x: any) => x.gstibo_project_name == projName);
          if (isPresent(tbl2)) {

            tbl2.forEach((element1: any) => {
              if (isPresent(element1['gstibo_month']) && isPresent(element1['gstibo_total_Expense'])) {
                let chSubData2 = [];
                chartColumns2 = ['Month', 'Expense'];
                chSubData2.push(this.month[element1['gstibo_month']]);
                chSubData2.push(element1['gstibo_total_Expense']);
                chData2.push(chSubData2);
              }
            });
          }
          else {
            chartColumns2 = ['Month', 'Expense'];
            let chSubData2 = [];
            chSubData2.push(this.month[1]);
            chSubData2.push(0);
            chData2.push(chSubData2);
          }

        }
        else {
          let myData: any = [];
          chartColumns1 = ['Month', 'Expense'];
          this.commonService.ogLog('myData:', myData);
          let chSubData2 = [];
          chSubData2.push(this.month[1]);
          chSubData2.push(0);
          chData2.push(chSubData2);
        }
        this.chartForm2ExpnseLength = chData2.length;
        /* else {
           let chSubData2 = [];
           chartColumns2 = ['TotalExpense', 'ProjectName']
           chSubData2.push('TotalExpense');
           chSubData2.push(0);
           chData2.push(chSubData2);
           chSubData2 = [];
           chSubData2.push('ProjectName');
           chSubData2.push(0);
           chData2.push(chSubData2);
           this.totalEmpCnt = '0';
           //chData2 = null;
         }*/
        this.chartForm2.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock2,
          width: '100%',
          height: '25rem',
          data: chData2,
          columnNames: chartColumns2,
          chartclick: 'true'


        });
        if ((qdata[2]['table']) && (qdata[2]['table'].length > 0) && this.projectList.length > 0) {
          let basePrjHrs = this.projectList.filter((x: any) => x.gstibo_project_id == this.defaultProjectId);
          this.commonService.ogLog('data3:', qdata[2]['table']);
          const tbl3 = (qdata[2]['table']).filter((x: any) => x.gstibo_Projectid == this.defaultProjectId);
          if (isPresent(tbl3)) {
            tbl3.forEach((element3: any) => {
              let chSubData3 = [];
              chartColumns3 = ['Month', 'Hours', 'Base'];
              chSubData3.push(this.month[element3['gstibo_Month']]);
              chSubData3.push(element3['gstibo_NoOfProjects']);
              chSubData3.push(basePrjHrs[0].gstibo_hours);
              // chSubData3.push(element3['gstibo_Holiday']);
              chData3.push(chSubData3);
            });
          }
          else {
            let chSubData3 = [];
            chartColumns3 = ['Month', 'Hours', 'Base'];
            chSubData3.push(this.month[1]);
            chSubData3.push(0);
            chSubData3.push(0);
            chData3.push(chSubData3);
          }
        } else {
          // qdata[2]['table'].forEach(element3 => {
          let chSubData3 = [];
          chartColumns3 = ['Month', 'Hours', 'Base'];
          chSubData3.push(this.month[1]);
          chSubData3.push(0);
          chSubData3.push(0);
          chData3.push(chSubData3);
          // });
          //chData3 = null;
        }
        this.chartForm3.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock3,
          // width: '100%',
          // height: '20rem',
          data: chData3,
          columnNames: chartColumns3
        });

      }, error => {
        console.log('forkjoin error');
      });

    });
    this.commonService.ogLog('this.chartForm2:', this.chartForm2);

    this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);
  }
  /** project dropdown in chart */
  loadProjects() {
    
    this.projectListData = [];
    //console.log('user id: ', this.commonService.getUserCredentials(KEYS.credential_account_id));
    let accountId = this.commonService.getUserCredentials(KEYS.credential_account_id);
    this.commonService.getProjects(accountId).subscribe((data: any) => {
      
      if (isData(data)) {
        this.projectListData = data['table'];
      }

      this.projectListData.push(
        {
          'gstibo_project_id': 0,
          'gstibo_project_name': "All",
        });
    });
    this.commonService.ogLog('data getProjects: ', this.projectListData);
  }
  loadOccupancy() {
    this.commonService.getoccupancyglancedetails().subscribe((data: any) => {
      if (isData(data)) {
        this.Occupancyglance = data['table'][0];
        console.log(this.Occupancyglance);
      }
    });

  }
  onPrjEmplist_change(emp: any) {
    this.defaultEmpProjectId = emp.target.value;
    this.commonService.ogLog('data getProjectsid: ', this.defaultEmpProjectId);
    this.commonService.setEmpDashboardProjectId(this.defaultEmpProjectId);
    this.router.navigate([this.routePath.dashboardUser], { queryParams: { dbu: this.defaultEmpProjectId, menuid: this.menuId } });
    // window.location.reload();

  }
  onLeaveEmplist_change(emp: any) {
    this.defaultEmpLeaveProjectId = emp.target.value;
    this.commonService.setEmpLeaveDashboardProjectId(this.defaultEmpLeaveProjectId);
    this.router.navigate([this.routePath.dashboardUser], { queryParams: { dbu: this.defaultEmpLeaveProjectId } });
  }
  redirecttomeeting() {
    this.commonService.setDashbord(false);
    this.router.navigate([this.routePath.Meeting]);
  }
  async getOutlookCalendarEvents() {
    this.commonService.ogLog('this.msAuthService.authenticated:', this.msAuthService.authenticated);
    if (this.msAuthService.authenticated) {
      if (this.msAuthService.user) {
        await this.fetchOutlookCalendarEvents(this.msAuthService.user)
      } else {
        await this.fetchOutlookCalendarEvents(await this.msAuthService.getUser())
      }
    }
  }
  async fetchOutlookCalendarEvents(msAuthUser: any) {
    this.commonService.ogLog('msAuthUser:', msAuthUser);
    this.meetingList = [];
    this.calenderEvents = [];
    const ianaName = findIana(msAuthUser ? msAuthUser.timeZone : 'UTC');
    const timeZone = ianaName![0].valueOf() || msAuthUser ? msAuthUser.timeZone : 'UTC';
    const now = new Date();
    const weekStart = toZonedTime(startOfWeek(now), timeZone);
    const weekEnd = toZonedTime(endOfWeek(now), timeZone);
    if (sessionStorage.getItem('outlookSignInLoadingMsgShown') === 'false') {
      this.commonService.setLoadingMessageLoader('Outlook SignIn In Progress...');
      sessionStorage.setItem('outlookSignInLoadingMsgShown', 'true');
    } else {
      this.commonService.setLoadingMessageLoader('');
    }
    this.loaderService.isLoading.next(true);
    this.meetingList = await this.graphService.getCalendarView(weekStart.toISOString(), weekEnd.toISOString(), msAuthUser.timeZone);
    this.commonService.ogLog('this.meetingList:', this.meetingList);
    for (let i = 0; i < this.meetingList?.length; i++) {
      this.commonService.setLoadingMessageLoader('');
      const existingEvent = this.calenderEvents.find((event: any) => event.id === this.meetingList[i].iCalUId);
      if (!existingEvent && this.meetingList[i].attendees?.length > 0
        && this.isFutureEventInCurrentOrNextMonth(this.meetingList[i].end.dateTime)) {
        this.calenderEvents.push(
          {
            id: this.meetingList[i].iCalUId,
            eventId: this.meetingList[i].id,
            organizer: this.meetingList[i].organizer.emailAddress.name,
            title: this.meetingList[i].subject + ' - ' + this.datePipe.transform(this.meetingList[i].start.dateTime, 'MMM d') +
              ' - ' + this.datePipe.transform(this.meetingList[i].start.dateTime, 'h:mm a'),
            date: this.datePipe.transform(this.meetingList[i].start.dateTime, 'MMM d'),
            onlineMeetingUrl: this.meetingList[i]?.onlineMeeting?.joinUrl ? this.meetingList[i].onlineMeeting.joinUrl : '',
            attendees: this.meetingList[i].attendees,
            startTime: this.datePipe.transform(this.meetingList[i].start.dateTime, 'h:mm a'),
            endTime: this.datePipe.transform(this.meetingList[i].end.dateTime, 'h:mm a'),
            subject: this.meetingList[i].subject,
            color: this.scheduleMeetingColor[i],
            Fulldate: new Date(this.datePipe.transform(this.meetingList[i].start.dateTime, 'yyyy-MM-dd')!)
          });
      }
    }
    this.calenderEvents.reverse();
    this.commonService.ogLog("this.calenderEvents", this.calenderEvents);

    let groupData = [];
    let weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    groupData = this.calenderEvents.reduce((acc: any, item: any) => {
      if (!acc[item.Fulldate]) {
        acc[item.Fulldate] = {
          day: weekDays[item.Fulldate.getDay()],
          meetings: []
        };
      }
      acc[item.Fulldate].meetings.push({
        startTime: item.startTime, endTime: item.endTime,
        subject: item.subject, organizer: item.organizer, color: item.color, onlineMeetingUrl: item.onlineMeetingUrl
      })
      return acc;
    }, {})
    this.groupDataMeeting = Object.values(groupData);
  }
  isFutureEventInCurrentOrNextMonth(endDateStr: string) {
    const now = new Date();
    const thisMonth = now.getMonth();
    const thisYear = now.getFullYear();

    const eventEndDate = new Date(endDateStr);
    const eventMonth = eventEndDate.getMonth();
    const eventYear = eventEndDate.getFullYear();

    const nextMonth = (thisMonth + 1) % 12;
    const nextMonthYear = thisMonth === 11 ? thisYear + 1 : thisYear;
    return (
      eventEndDate > now &&
      (
        (eventMonth === thisMonth && eventYear === thisYear) ||
        (eventMonth === nextMonth && eventYear === nextMonthYear)
      )
    );
  }
  loadMeetingdetails() {
    this.MeetingList = [];
    //this.MeetingListnew=[];
    let accountId = this.commonService.getUserCredentials(KEYS.credential_account_id);
    let meetingtype = "Zoom";
    this.commonService.loadMeetingdetails(meetingtype, accountId, 0).subscribe((data: any) => {
      if (isData(data)) {
        const datas = data['table1'];
        this.commonService.ogLog('datas : ', datas);
        try {
          this.MeetingList = [];
          datas.forEach((element: any) => {
            //  if (this.datepipe.transform(element.gstibo_meeting_starttime, "hh:mm a") <= this.datepipe.transform(new Date(), "hh:mm a")) {
            this.MeetingList.push(
              {

                'Topic': element.gstibo_meeting_topic,
                'StartTime': (element.gstibo_meeting_isrecurring == 1) ? this.datepipe.transform(element.gstibo_meeting_starttime, "hh:mm a") : this.datepipe.transform(element.gstibo_meeting_starttime, "MMM d , hh:mm a"),
                'JoinUrl': element.gstibo_meeting_joinurl,
                'MeetingID': element.gstibo_meeting_ID,
                'Hostby': element.hostby

              }
            );
            //}
          });
          //this.MeetingListnew=this.MeetingList;
        } catch (e) { }

        this.commonService.ogLog('meetingdata:', this.MeetingList);
      } else {
        this.commonService.ogLog('loadManagemeeting No Rows found');
      }

    },
      error => {
        console.log('get loadmeeting list Error:', error);
      });

    if (this.MeetingList.length > 0) {

    }
  }

  loadTemplatefive(dashboardId: string) {
    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      legendPosition: 'bottom'
    });
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      bar: '',
      colors: '',
      chartArea: {}
    });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: '',
      chartArea: {}
    });
    this.chartForm4 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: '',
      chartArea: {}
    });
    this.chartForm5 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: '',
      chartArea: {},
      legendPosition: 'bottom',
      bargroupwidth: '',
      legendMaxLine: '',
      bar: '',
    });
    this.chartForm6 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId);
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock7: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock4Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        chartBlock5Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        chartBlock6Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_heading'] : ''),
        chartBlock7Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_heading'] : '')
      });
      this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm)
      const chartQuery0 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Opportunity_Tiles");
      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_opportunity_revenueclosed");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_opportunity_deal_lost_won");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Opportunity_Tiles");
      const chartQuery4 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Top10_Open_Opportunity");
      const chartQuery5 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Top10_Won_Opportunity");
      const chartQuery6 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Opportunity_Campaign_Type");
      const chartQuery7 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Opportunity_Revenu_month");
      const chartQuery8 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Opportunity_TaskComplition")

      forkJoin([chartQuery0, chartQuery1, chartQuery2, chartQuery3, chartQuery4, chartQuery5, chartQuery6, chartQuery7, chartQuery8]).subscribe((qdata: any[]) => {
        let chData1: any[] = [];
        let chData2: any[] = [];
        let chData3: any[] = [];
        let chData4: any[] = [];
        let chData5: any[] = [];
        let chData6: any[] = [];
        let chData7: any[] = [];
        let chart1Columns: any[] = [];
        let chart3Columns: any[] = [];
        let chart4Columns: any[] = [];
        let chart6Columns: any[] = [];
        this.commonService.ogLog('qdata : ', qdata);
        if (qdata[0]['table']) {
          this.leadTiles = qdata[0]['table'];
        }
        if ((qdata[1]['table']) && (qdata[1]['table'].length > 0)) {
          qdata[1]['table'].forEach((element1: any) => {
            let chSubData1 = [];
            const val = qdata[1]['table'][0]['gstibo_value'];
            chData1 = [
              ['Value', val]
            ];
          });
          this.commonService.ogLog('chData1:', chData1);
          this.commonService.ogLog('data1:', qdata[1]['table']);
        } else {
          let chSubData1 = [];
          chart1Columns.push('0');
          chSubData1.push('0');
          chSubData1.push('0');
          chData1.push(chSubData1);
        }
        this.chartForm1.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock1,
          width: '100%',
          height: '25rem',
          data: chData1,
          columnNames: chart1Columns,
          legendPosition: 'bottom',

        });
        let chSubData1 = [];
        if (qdata[2]['table']) {
          chart1Columns = ['Name', 'Deal Won', 'Deal Lost'];
          qdata[2]['table'].forEach((element1: any) => {
            chSubData1 = [];
            chSubData1.push(element1.gstibo_name);
            chSubData1.push(element1.gstibo_deallost);
            chSubData1.push(element1.gstibo_dealwon);
            chData2.push(chSubData1);
          });
        }
        else {
          chart1Columns = ['Name', 'Deal Won', 'Deal Lost'];
          chSubData1 = [];
          chSubData1.push('');
          chSubData1.push(0);
          chSubData1.push(0);
          chData2.push(chSubData1);

        }
        this.commonService.ogLog('Deal chart data : ', chData2);
        this.chartForm2.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock2,
          width: '100%',
          height: '20rem',
          data: chData2,
          columnNames: chart1Columns,
          legendPosition: 'bottom',
          bar: 'horizontal',
          colors: ['#2CD9C5', '#2D9AFF'],
          chartArea: {
            bottom: 20,
            right: 20,
            left: 20,
            top: 20

          },
        });
        if ((qdata[4]['table']) && (qdata[4]['table'].length > 0)) {
          this.top10Opportunity = qdata[4]['table'];
        }
        if ((qdata[5]['table']) && (qdata[5]['table'].length > 0)) {
          this.top10wonOpportunity = qdata[5]['table'];
        }
        if (qdata[6]['table']) {
          this.commonService.ogLog('chData7:', qdata[6]['table']);
          qdata[6]['table'].forEach((element2: any) => {
            let chSubData2 = [];
            chart3Columns.push(element2.gstibo_Campaign_Name);
            chSubData2.push(element2.gstibo_Campaign_Name);
            chSubData2.push(element2.gstibo_per);
            chData3.push(chSubData2);
          });
        } else {
          let chSubData2 = [];
          chart3Columns = ['', '']
          chSubData2.push('');
          chSubData2.push(0);
          chData2.push(chSubData2);
          chSubData2 = [];
          chSubData2.push('');
          chSubData2.push(0);
          chData3.push(chSubData2);

        }
        this.chartForm3.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock3,
          width: '100%',
          height: '20rem',
          data: chData3,
          columnNames: ['Item', 'Value'],
          colors: ['#2D99FE', '#FF4D8E', '#826BFA', '#2CD9C5', '#FF6C40'],
          chartArea: {
            bottom: 20,
            right: 20,
            left: 20,
            top: 20

          },
        });
        let chSubData3 = [];
        if (qdata[7]['table']) {

          chart6Columns = ['Month', 'Value'];
          qdata[7]['table'].forEach((element1: any) => {
            chSubData3 = [];
            chSubData3.push(element1.gstibo_Month_Name);
            chSubData3.push(element1.gstibo_per);
            chData7.push(chSubData3);
          });
        }
        else {
          chart6Columns = ['Month', 'Value'];
          chSubData3 = [];
          chSubData3.push('');
          chSubData3.push(0);
          chData7.push(chSubData3);
        }
        this.commonService.ogLog('estimated chart data : ', chData7);
        this.chartForm4.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock4,
          data: chData7,
          columnNames: chart6Columns,
          legendPosition: 'bottom',
          bar: 'horizontal',
          colors: ['#19C792', '#F94350'],
          chartArea: {
            bottom: 20,
            right: 20,
            left: 20,
            top: 20

          },
        });
        let chSubData4 = [];
        let chart8Columns = ['Task', 'Sucess', 'Fail', 'Abondon', { role: 'annotation' }];
        if (qdata[8]['table']) {
          qdata[8]['table'].forEach((element1: any) => {
            chSubData4 = [];
            chSubData4.push(element1.gstibo_Task_Name);
            chSubData4.push(element1.gstibo_Sucessvalue);
            chSubData4.push(element1.gstibo_Failvalue);
            chSubData4.push(element1.gstibo_Abondonvalue);
            chSubData4.push(element1.gstibo_Abondonvalue);
            chData5.push(chSubData4);
          });
        }
        else {
          chSubData4 = [];
          chSubData4.push('');
          chSubData4.push(0);
          chSubData4.push(0);
          chSubData4.push(0);
          chSubData4.push(0);
          chData5.push(chSubData4);

        }
        this.commonService.ogLog('task chart data : ', chData5);
        this.chartForm5.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock5,
          data: chData5,
          columnNames: chart8Columns,
          legendPosition: 'bottom',
          bargroupwidth: "75%",
          colors: ['#02E478', '#F94350', '#826BFA'],
          chartArea: {
            bottom: 20,
            right: 20,
            left: 20,
            top: 20

          },
          legendMaxLine: 3,
          bar: 'horizontal'
        });

      }, error => {
        console.log('forkjoin error');
      });

    });

    this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);

  }
  loadTemplatesix(dashboardId: string) {
    let chartColumns1: any[] = [];
    let chartColumns2: any[] = [];
    let chartColumns3: any[] = [];
    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: [null]
    });
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: [null],
      chartArea: {}
    });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: [null]
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId);
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.empasidebox = dashboardChartData.filter((x: any) => x.gstibo_chart_type == 'Asidebox');
      this.commonService.ogLog('empasidebox', this.empasidebox);
      if (this.empasidebox.length == 0) {
        //let data = [{ gstibo_chart_heading: "Profile Details" }, { gstibo_chart_heading: "Absent Employee" }];
        let data = [{ gstibo_chart_heading: "Absent Employee" }];
        this.empasidebox = data;
      }
      if (this.empasidebox.length >= 1) {
        this.empasidebox = this.empasidebox.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock2');
        try {
          if (this.empasidebox[0].gstibo_chart_heading == 'Profile Details' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock2')
            this.empasidebox.push({ gstibo_chart_heading: "Profile Details" });
          if (this.empasidebox[0].gstibo_chart_heading == 'Absent Employee' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock2')
            this.empasidebox.push({ gstibo_chart_heading: "Absent Employee" });
        }
        catch (e) { }
        // if (this.empasidebox[0].gstibo_chart_heading == 'Profile Details' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock1')
        //   this.empasidebox.push({ gstibo_chart_heading: "Absent Employee" });
        // if (this.empasidebox[0].gstibo_chart_heading == 'Absent Employee' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock2') {
        //   this.empasidebox = [];
        //   let data = [{ gstibo_chart_heading: "Profile Details" }, { gstibo_chart_heading: "Absent Employee" }];
        //   this.empasidebox = data;
        // }
        // if (this.empasidebox[0].gstibo_chart_heading == 'Profile Details' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock2')
        //   this.empasidebox.push({ gstibo_chart_heading: "Profile Details" });
        // if (this.empasidebox[0].gstibo_chart_heading == 'Absent Employee' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock1')
        //   this.empasidebox.push({ gstibo_chart_heading: "Absent Employee" })
      }
      // if (this.empasidebox.length > 1) {
      //   if (this.empasidebox[0].gstibo_chart_heading == 'Absent Employee' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock1'
      //     && this.empasidebox[1].gstibo_chart_heading == 'Profile Details' && this.empasidebox[1].gstibo_chart_block_id == 'emp_asideblock2') {
      //     this.empasidebox = [];
      //     let data = [{ gstibo_chart_heading: "Absent Employee" }, { gstibo_chart_heading: "Profile Details" }];
      //     this.empasidebox = data;
      //   }
      //   if (this.empasidebox[0].gstibo_chart_heading == 'Profile Details' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock2' &&
      //     this.empasidebox[1].gstibo_chart_heading == 'Absent Employee' && this.empasidebox[1].gstibo_chart_block_id == 'emp_asideblock1') {
      //     this.empasidebox = [];
      //     let data = [{ gstibo_chart_heading: "Absent Employee" }, { gstibo_chart_heading: "Profile Details" }];
      //     this.empasidebox = data;
      //   }
      //   if (this.empasidebox[0].gstibo_chart_heading == 'Absent Employee' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock2'
      //     && this.empasidebox[1].gstibo_chart_heading == 'Profile Details' && this.empasidebox[1].gstibo_chart_block_id == 'emp_asideblock1') {
      //     this.empasidebox = [];
      //     let data = [{ gstibo_chart_heading: "Profile Details" }, { gstibo_chart_heading: "Absent Employee" }];
      //     this.empasidebox = data;
      //   }
      //}
      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : ''),

      });
      this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);

      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_ProjectsTracked");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_dashboard_departmentwiseexpense");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_LeaveComposition");
      this.commonService.ogLog('chartquery2', chartQuery2);
      forkJoin([chartQuery1, chartQuery2, chartQuery3]).subscribe((qdata: any) => {
        
        let chData1 = [];
        let chData2 = [];
        let chData3 = [];
        //console.log('qdata : ', qdata);
        if ((qdata[0]['table']) && (qdata[0]['table'].length > 0)) {
          
          let myData = [];
          chartColumns1 = ['Month', 'Hours'];
          //console.log('myData:', myData);
          //console.log('qdata[0]', qdata[0]['table']);
          if (this.defaultEmpProjectId == '0') {
            let myMap = new Map();
            let allData = [];
            qdata[0]['table'].forEach((element1: any) => {
              if (myMap.has(this.month[element1.gstibo_Month])) {
                let monVal = 0;
                monVal = myMap.get(this.month[element1.gstibo_Month])
                myMap.set(this.month[element1.gstibo_Month], element1.gstibo_NoOfProjects + monVal)
              } else {
                myMap.set(this.month[element1.gstibo_Month], element1.gstibo_NoOfProjects);
              }
            })

            this.commonService.ogLog(myMap, "myMap...................")
            allData = Array.from(myMap)
            this.commonService.ogLog(allData, "allData...................")

            chData1 = allData;
          } else {
            const empPrjId = (qdata[0]['table']).filter((x: any) => x.gstibo_Projectid == this.defaultEmpProjectId);
            if (isPresent(empPrjId)) {
              empPrjId.forEach((element1: any) => {
                let chSubData1 = [];
                chSubData1.push(this.month[element1['gstibo_Month']]);
                chSubData1.push(element1['gstibo_NoOfProjects']);
                chData1.push(chSubData1);
              });
            } else {
              let chSubData1 = [];
              chartColumns1 = ['Month', 'Hours'];
              chSubData1.push(this.month[1]);
              chSubData1.push(0);
              chData1.push(chSubData1);
            }

          }
          //console.log('chData1:', chData1);
          //console.log('data1:', qdata[0]['table']);
        } else {
          let myData = [];
          chartColumns1 = ['Month', 'Hours'];
          // console.log('myData:', myData);
          // qdata[0]['table'].forEach(element1 => {
          let chSubData1 = [];
          chSubData1.push(this.month[1]);
          chSubData1.push(0);
          chData1.push(chSubData1);
          // });
          // chData1 = null;
        }
        this.chartForm1.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock1,
          width: '100%',
          height: '16.7rem',
          data: chData1,
          columnNames: chartColumns1,
          colors: ['#0177ff', '#79b5fd', '#ff953b', '#ff3b5b']//['#08e3a3', '#6735f6', '#f28201', '#ff3b5b']
        });
        if ((qdata[1]['table']) && (qdata[1]['table'].length > 0)) {
          // chartColumns2 = ['Men', 'Women']
          // chSubData2.push('Men');
          // chSubData2.push(qdata[1]['table'][0]['gstibo_Men']);
          // chData2.push(chSubData2);
          // chSubData2 = [];
          // chSubData2.push('Women');
          // chSubData2.push(qdata[1]['table'][0]['gstibo_Women']);
          // chData2.push(chSubData2);
          let total = 0;
          qdata[1]['table'].forEach((element2: any) => {
            let chSubData2 = [];
            chartColumns2.push(element2.gstibo_DeptName);
            chSubData2.push(element2.gstibo_DeptName);
            chSubData2.push(element2.gstibo_ExpenseValue);
            chData2.push(chSubData2);
            total += Number(element2.gstibo_ExpenseValue);
          });
          this.totalEmpCnt = total.toString();
        } else {
          
          let chSubData2 = [];
          chartColumns2 = ['', '']
          chSubData2.push('');
          chSubData2.push(0);
          chData2.push(chSubData2);
          chSubData2 = [];
          chSubData2.push('');
          chSubData2.push(0);
          chData2.push(chSubData2);
          this.totalEmpCnt = '0';
          //chData2 = null;
        }
        this.chartForm2.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock2,
          // width: '100%',
          height: '16.7rem',
          data: chData2,
          columnNames: chartColumns2,
          colors: ['#f28202', '#f908b6', '#ff953b', '#ff3b5b'],
          chartArea: {
            bottom: 20,
            left: 0,
            right: 0,
            top: 20
          }
        });
        if ((qdata[2]['table']) && (qdata[2]['table'].length > 0)) {
          
          //console.log('data3:', qdata[2]['table']);
          if (this.defaultEmpLeaveProjectId == '0') {
            let myMap = new Map();
            let allData: any[] = [];
            let MainData: any[] = [];
            qdata[2]['table'].forEach((element3: any) => {
              if (myMap.has(this.month[element3.gstibo_Month])) {
                let myNewMap = new Map();
                myNewMap = myMap.get(this.month[element3.gstibo_Month]);
                myNewMap.set("casual", element3['gstibo_Casual'] + myNewMap.get("casual"));
                myNewMap.set("sick", element3['gstibo_Sick'] + myNewMap.get("sick"));
                myNewMap.set("holiday", element3['gstibo_Holiday'] + myNewMap.get("holiday"));

                myMap.set(this.month[element3.gstibo_Month], myNewMap);
              } else {
                let myNewMap = new Map();
                myNewMap.set("casual", element3['gstibo_Casual']);
                myNewMap.set("sick", element3['gstibo_Sick']);
                myNewMap.set("holiday", element3['gstibo_Holiday'])
                myMap.set(this.month[element3.gstibo_Month], myNewMap);
              }
            })
            MainData = Array.from(myMap);
            MainData.forEach(map => {
              let innerMap: any[] = Array.from(map[1]);
              let innerData: any[] = [];
              innerData.push(map[0]);
              innerData.push(innerMap[0][1]);
              innerData.push(innerMap[1][1]);
              innerData.push(innerMap[2][1]);
              allData.push(innerData);
              // allData = ['Oct', 1, 1, 1];
            });
            //console.log(allData, "allData...................")
            chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
            chData3 = allData;
            //console.log(chData3, "chData3default0...................")

          }
          else {
            const empLeavePrjId = (qdata[2]['table']).filter((x: any) => x.gstibo_Projectid == this.defaultEmpLeaveProjectId);
            if (isPresent(empLeavePrjId)) {
              empLeavePrjId.forEach((element3: any) => {
                let chSubData3 = [];
                chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
                chSubData3.push(this.month[element3['gstibo_Month']]);
                chSubData3.push(element3['gstibo_Casual']);
                chSubData3.push(element3['gstibo_Sick']);
                chSubData3.push(element3['gstibo_Holiday']);
                chData3.push(chSubData3);
              });
            } else {
              let chSubData3 = [];
              chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
              chSubData3.push(this.month[1]);
              chSubData3.push(0);
              chSubData3.push(0);
              chSubData3.push(0);
              chData3.push(chSubData3);
            }
            //console.log(chData3, "chData3InprjId...................")
          }

        } else {
          // qdata[2]['table'].forEach(element3 => {
          let chSubData3 = [];
          chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
          chSubData3.push(this.month[1]);
          chSubData3.push(0);
          chSubData3.push(0);
          chSubData3.push(0);
          chData3.push(chSubData3);
          // });
          //chData3 = null;
        }
        this.chartForm3.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock3,
          width: '100%',
          height: '16.7rem',
          data: chData3,
          columnNames: chartColumns3,
          colors: ['#08e3a3', '#6735f6', '#f28201', '#ff3b5b']
        });

        this.empasidebox1 = this.dashboardTemplateForm.value.emp_asideblock1
        this.empasidebox2 = this.dashboardTemplateForm.value.emp_asideblock2
        this.commonService.ogLog('this.empasidebox1', this.empasidebox1);
        this.commonService.ogLog('this.empasidebox2', this.empasidebox2);
      }, error => {
        console.log('forkjoin error');
      });

    });

    this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);
  }
  loadTemplateseven(dashboardId: string) {
    let chartColumns1: any[] = [];
    let chartColumns2: any[] = [];
    let chartColumns3: any[] = [];
    let chartColumns4: any[] = [];
    let chartColumns5: any[] = [];
    let chartColumns6: any[] = [];
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: [null],
      chartArea: {}
    });
    this.chartForm4 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [],
      columnNames: [null],
      height: '',
      colors: [null],
      chartArea: {}
    });
    this.chartForm5 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [],
      columnNames: [null],
      height: '',
      colors: [null],
      chartArea: {}
    });
    this.chartForm6 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [],
      columnNames: [null],
      height: '',
      colors: [null],
      chartArea: {},
      bar: {}
    });
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        crmCB1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1'))[0]['gstibo_chart_type'] : ''),
        crmCB2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2'))[0]['gstibo_chart_type'] : ''),
        crmCB3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3'))[0]['gstibo_chart_type'] : ''),
        crmCB4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4'))[0]['gstibo_chart_type'] : ''),
        crmCB5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5'))[0]['gstibo_chart_type'] : ''),
        crmCB6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crmChartBlock6'))[0]['gstibo_chart_type'] : ''),
        crmCB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        crmCB2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        crmCB3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        crmCB4Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        crmCB5Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        crmCB6Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crmChartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crmChartBlock6'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_staticBlock1'))[0]['gstibo_chart_heading'] : '')
      });
      console.log('dashboardTemplateForm : ', this.dashboardTemplateForm);
      const chartQuery1 = this.commonService.executedynamicquery("select *,'' as color from gstibo_dev_Dboard_CRM_DealsProgressByCount order by tbl_id asc");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_CountOfLeads");
      const chartQuery3 = this.commonService.executedynamicquery("select *,'' as colorclass from gstibo_dev_Dboard_CRM_Deals");
      const chartQuery4 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_LeadConversationAnalytics");
      const chartQuery5 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_TotalValueConverted");
      const chartQuery6 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_BudgetVsActual");
      const chartQuery7 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_Tiles order by gstibo_id asc");
      const chartQuery8 = this.commonService.executedynamicquery("select Top 5* from gstibo_dev_Dboard_CRM_Top_Items order by gstibo_id asc");
      forkJoin(
        [
          chartQuery1, chartQuery2, chartQuery3,
          chartQuery4, chartQuery5, chartQuery6,
          chartQuery7, chartQuery8
        ]
      ).subscribe((qdata: any[]) => {
        let chData1: any[] = [];
        let chData2: any[] = [];
        let chData3: any[] = [];
        let chData4: any[] = [];
        let chData5: any[] = [];
        let chData6: any[] = [];
        this.commonService.ogLog('qdata : ', qdata);
        if (qdata[0]['table']) {
          this.dealsProgress = qdata[0]['table'];
          for (let i = 0; i < this.dealsProgress.length; i++) {
            if (this.DealProgressColoredArray[i])
              this.dealsProgress[i].color = this.DealProgressColoredArray[i];
          }

        }
        if ((qdata[1]['table']) && qdata[1]['table'].length > 0) {
          let value1 = [];
          let value2 = [];
          let value3 = [];
          value1.push('Leads Created');
          value2.push('Proposal Made');
          value3.push('Closed the deal');
          chartColumns2.push('Items');
          qdata[1]['table'].forEach((element3: any) => {
            value1.push(element3['gstibo_Value1']);
            value2.push(element3['gstibo_Value2']);
            value3.push(element3['gstibo_Value3']);
            chartColumns2.push(element3['gstibo_item']);
          });
          chData2.push(value1, value2, value3);
          this.commonService.ogLog('chData2 : ', chData2);
          this.chartForm2.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB2,
            width: '100%',
            height: '15rem',
            data: chData2,
            columnNames: chartColumns2,
            colors: ["#b8272a", "#0b66c3", "#00c2ff"],
            chartArea: {
              bottom: 40,
              left: 10,
              right: 10,
              top: 10
            }
          });
          console.log('chartForm2 : ', this.chartForm2);
        }
        else {
          let value1 = [];
          let value2 = [];
          let value3 = [];
          value1.push('Leads Created');
          value2.push('Proposal Made');
          value3.push('Closed the deal');
          chartColumns2.push('Items');
          value1.push(0);
          value2.push(0);
          value3.push(0);
          chartColumns2.push('');
          chData2.push(value1, value2, value3);
          this.chartForm2.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB2,
            //width: '100%',
            height: '15rem',
            data: chData2,
            columnNames: chartColumns2,
            colors: ["#b8272a", "#0b66c3", "#00c2ff"],
            chartArea: {
              bottom: 40,
              left: 10,
              right: 10,
              top: 10
            }
          });
          this.commonService.ogLog('chartForm2 : ', this.chartForm2);
        }
        if (qdata[2]['table']) {
          this.dealsPivote = qdata[2]['table'];
          for (let i = 0; i < this.dealsPivote.length; i++) {
            if (this.dealsPivotecoloredArray[i])
              this.dealsPivote[i].colorclass = this.dealsPivotecoloredArray[i];
          }
        }
        if (qdata[3]['table']) {
          this.leadConversation = qdata[3]['table'];
          console.log('this.leadConversation', this.leadConversation);
        } else {
          const leadSample = [{
            gstibo_created_value: 0,
            gstibo_converted_value: 0,
            gstibo_won_value: 0,
            gstibo_lost_value: 0,
            gstibo_created_per: 0,
            gstibo_converted_per: 0,
            gstibo_won_per: 0,
            gstibo_lost_per: 0
          }];
          this.leadConversation = leadSample;
        }
        if ((qdata[4]['table']) && qdata[4]['table'].length > 0) {
          chartColumns5 = ['Month', 'Casual', 'Sick', 'Holiday'];
          const val = qdata[4]['table'][0]['gstibo_value'];
          const gaugeData = [
            ['Value', val]
          ];
          this.chartForm5.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB5,
            //width: '100%',
            height: '14rem',
            data: gaugeData,
            columnNames: chartColumns5,
            colors: ['#6852c8', '#69d141', '#ff953b', '#ff3b5b'],
            chartArea: {
              bottom: 10,
              left: 10,
              right: 10,
              top: 10
            }
          });
          this.commonService.ogLog('chartForm5 : ', this.chartForm5);
        }
        if ((qdata[5]['table']) && (qdata[5]['table'].length > 0)) {
          qdata[5]['table'].forEach((element3: any) => {
            let chSubData6 = [];
            chartColumns6 = ['Year', 'Budget', 'Actual'];
            chSubData6.push(element3['gstibo_year']);
            chSubData6.push(element3['gstibo_budget']);
            chSubData6.push(element3['gstibo_Actual']);
            chData6.push(chSubData6);
          });
          this.chartForm6.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB6,
            width: '100%',
            height: '15rem',
            data: chData6,
            columnNames: chartColumns6,
            bar: { groupWidth: '20%' }
          });
          this.commonService.ogLog('chartForm6 : ', this.chartForm6);
        }
        else {
          let chSubData6 = [];
          chartColumns6 = ['Year', 'Budget', 'Actual'];
          chSubData6.push('');
          chSubData6.push(0);
          chSubData6.push(0);
          chData6.push(chSubData6);
          this.chartForm6.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB6,
            width: '100%',
            height: '15rem',
            data: chData6,
            columnNames: chartColumns6,
            bar: { groupWidth: '50%' }
          });
        }
        if (qdata[6]['table']) {
          this.leadTiles = qdata[6]['table'];
        }
        if (qdata[7]['table']) {
          this.top5Deals = qdata[7]['table'];
          this.commonService.ogLog('top5Deals', this.top5Deals)
        }
      }, error => {
        console.log('forkjoin error');
      });
    }, error => {
      console.log('forkjoin error');
    });
  }
  loadTemplateeight(dashboardId: string) {
    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      legendPosition: 'bottom',
      bargroupwidth: ''
    });
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      pieHole: '',
      legendPosition: '',
      color: []
    });
    this.chartForm4 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm5 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm6 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId);
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock7: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock4Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        chartBlock5Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        chartBlock6Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_heading'] : ''),
        chartBlock7Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_heading'] : '')
      });
      console.log('this.dashboardTemplateForm:', this.dashboardTemplateForm)
      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_OpenReqByDepartment");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_EfficiencyOfHiring order by gstibo_id asc");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_Recruitment order by gstibo_value desc");
      const chartQuery4 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_Turnover");
      const chartQuery5 = this.commonService.executedynamicquery("select * , '' color,'' colorbar from gstibo_dev_Dboard_rec_HiresBySource");
      const chartQuery6 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_HireByGrade where gstibo_col1 <>'' ");
      const chartQuery7 = this.commonService.executedynamicquery("select * ,'' color from gstibo_dev_Dboard_rec_OfferDecline  order by gstibo_item");
      const chartQuery8 = this.commonService.executedynamicquery("select * ,'' color from gtstibo_dev_Dboard_rec_Tiles");

      forkJoin([chartQuery1, chartQuery2, chartQuery3, chartQuery4, chartQuery5, chartQuery6, chartQuery7, chartQuery8]).subscribe((qdata: any) => {
        let chData1: any[] = [];
        let chData2: any[] = [];
        let chData3: any[] = [];
        let chData4: any = [];
        let chData5: any[] = [];
        let chData6: any[] = [];
        let chData7: any[] = [];
        let chart1Columns: any[] = [];
        let chart3Columns: any[] = [];
        let chart5Columns: any[] = [];
        let chart6Columns: any[] = [];
        chart1Columns = ['Department', 'Percentage'];
        this.commonService.ogLog('qdata : ', qdata);
        let chSubData: any[] = [];
        chSubData.push('Element');
        chSubData.push('Density');
        chSubData.push({ role: "style" });
        //chData1.push(chSubData);
        //"Element", "Density", { role: "style" }

        if ((qdata[0]['table']) && (qdata[0]['table'].length > 0)) {
          qdata[0]['table'].forEach((element1: any) => {
            let chSubData1: any[] = [];
            //chart1Columns.push(element1.gstibo_dept);
            // chSubData1.push({'Dept':element1.gstibo_dept,'value':element1.gstibo_value,'color':''})
            chSubData1.push(element1.gstibo_dept);
            chSubData1.push(element1.gstibo_value);
            chData1.push(chSubData1);
          });
          this.commonService.ogLog('chData1:', chData1);
          this.commonService.ogLog('data1:', qdata[0]['table']);
        } else {
          // qdata[0]['table'].forEach(element1 => {
          let chSubData1 = [];
          chart1Columns.push('0');
          chSubData1.push('0');
          chSubData1.push('0');
          chData1.push(chSubData1);
          // });
          //chData1 = null;
        }
        let colors = ['#525be4', '#9c52fd', '#ef0c51', '#24e4ab', '#ef0c51', '#24e4ab'];
        if (chData1.length > 0) {
          //  for (let i=0;i<chSubData1.length;i++)
          //  {
          //    console.log('chData1[i]',chData1[i])
          //    if(colors[i])
          //    chSubData1[i].color=colors[i];
          //  }
          // for (let i=0;i<chData1.length;i++)
          //  {
          //    console.log('chData1[i]',chData1[i])
          //    if(colors[i])
          //    chData1[i].push('color:+colors[i]+');
          //  }
          //chData1.push(chSubData1);
          this.chartForm1.patchValue({
            chartType: this.dashboardTemplateForm.value.chartBlock1,
            width: '100%',
            height: '20rem',
            data: chData1,
            columnNames: chart1Columns,
            legendPosition: 'top',
            color: colors,
            bar: "35%",//requisition
            // legend: { position: "none" },
            bargroupwidth: '2',

          });
          this.commonService.ogLog('this.chartForm1', this.chartForm1);
        }
        if (qdata[1]['table']) {
          this.roundChartEffHiring = qdata[1]['table'];
          let total = 0;

          if ((qdata[1]['table']) && (qdata[1]['table'].length > 0)) {
            qdata[1]['table'].forEach((element2: any) => {
              let chSubData3 = [];
              total += Number(element2.gstibo_value);
              chart3Columns.push(element2.gstibo_Item);
              chSubData3.push(element2.gstibo_Item);
              chSubData3.push(element2.gstibo_value);
              chData3.push(chSubData3);
            });
          }
          else {
            let chSubData3 = [];
            chart3Columns.push('0');
            chSubData3.push('0');
            chSubData3.push('0');
            chData3.push(chSubData3);
          }
          this.commonService.ogLog('chData3', chData3);
          this.totalEHValue = total.toString();
          this.commonService.ogLog('this.roundChartEffHiring', this.roundChartEffHiring)
          this.chartForm3.patchValue({
            chartType: this.dashboardTemplateForm.value.chartBlock2,
            width: '31rem',
            height: '20rem',
            data: chData3,
            columnNames: chart3Columns,
            legendPosition: 'right',
            pieHole: '0.1',
            chartArea: {
              bottom: 0,
              right: 0,
              left: 0,
              top: 20

            }
          });
        }
        if (qdata[2]['table']) {
          this.commonService.ogLog('data3:', qdata[2]['table']);
          this.recruitmentFunnel = qdata[2]['table'];
        }
        if (qdata[3]['table']) {
          qdata[3]['table'].forEach((element1: any) => {
            let chSubData4 = [];
            chSubData4.push(element1.gstibo_year);
            chSubData4.push(element1.gstibo_value1);
            chSubData4.push(element1.gstibo_value1);
            chSubData4.push(element1.gstibo_value1);
            chData4.push(chSubData4);
          });
          this.commonService.ogLog('chData4:', chData4);
        } else {
          chData4 = null;
        }
        this.chartForm4.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock4,
          width: '100%',
          height: '20rem',
          data: chData4,
          columnNames: ['Year', 'Value1', 'Value2', 'Value3']
        });
        this.recuirtmentnewhire = qdata[4]['table'];
        this.commonService.ogLog('qdata[4]:', qdata[4]['table']);
        if ((qdata[4]['table']) && (qdata[4]['table'].length > 0)) {
          for (let i = 0; i < this.recuirtmentnewhire.length; i++) {
            chart5Columns.push({ "name": this.recuirtmentnewhire[i].gstibo_Item, "color": this.recuritmenthirecoloredArray[i] });
          }
          for (let i = 0; i < this.recuirtmentnewhire.length; i++) {
            chData5.push({ "name": this.recuirtmentnewhire[i].gstibo_Item, "value": this.recuirtmentnewhire[i].gstibo_value, "color": this.recuritmenthirbarecoloredArray[i] });//
          }
          qdata[4]['table'].forEach((element1: any) => {
            let chSubData5 = [];
            //chart5Columns.push(element1.gstibo_Item);
            chSubData5.push(element1.gstibo_Item);
            chSubData5.push(element1.gstibo_value);
            chData5.push(chSubData5);
          });
          this.commonService.ogLog('chart5Columns:', chart5Columns);
          this.commonService.ogLog('data5:', qdata[4]['table']);
        } else {
          let chSubData5 = [];
          chart5Columns.push('0');
          chSubData5.push('0');
          chSubData5.push('0');
          chData5.push(chSubData5);
          //chData5 = null;
        }
        this.commonService.ogLog('chData5', chData5);
        this.chartForm5.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock5,
          // width: '100%',
          height: '20rem',
          data: chData5,
          columnNames: chart5Columns,
          legendPosition: 'bottom'
        });
        // this.commonService.ogLog('chData5', this.chartForm5.controls.data.value);
        if ((qdata[5]['table']) && (qdata[5]['table'].length > 0)) {
          qdata[5]['table'].forEach((element1: any) => {
            let chSubData6 = [];
            chSubData6.push(element1.gstibo_item);
            chSubData6.push(element1.gstibo_value);

            chData6.push(chSubData6);
          });

        } else {
          let chSubData6 = [];
          chSubData6.push('0');
          chSubData6.push(0);
          chData6.push(chSubData6);
          //chData6 = null;
        }
        let chSubData6 = [];
        // chSubData6.push('Test');
        // chSubData6.push('100');
        // chData6.push(chSubData6);
        this.chartForm6.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock6,
          width: '100%',
          height: '20rem',
          data: chData6,//bygrades
          columnNames: ['Item', 'Value']
        });
        if (qdata[6]['table']) {
          this.offerDecline = qdata[6]['table'];
          for (let i = 0; i < this.offerDecline.length; i++) {
            this.offerDecline[i].color = this.DealProgressColoredArray[i];
            // this.offerDecline.push({"gstibo_Item":this.offerDecline[i].gstibo_Item,"gstibo_value":this.recuirtmentnewhire[i].gstibo_value,
            // "color":this.DealProgressColoredArray[i],"gstibo_per":this.offerDecline[i].gstibo_Item});//
          }
          this.commonService.ogLog('chData7:', qdata[6]['table']);
        }
        if (qdata[7]['table']) {
          this.recruirtmenttiles = qdata[7]['table'];
        }
      }, error => {
        console.log('forkjoin error');
      });

    });

    this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);

  }

  loadTemplatesten(dashboardId: string) {
    this.loadMeetingdetailsnew();
    let chartColumns1 = [];
    let chartColumns2 = [];
    let chartColumns3 = [];
    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: [null]
    });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: [null]
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId);
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.empasidebox = dashboardChartData.filter((x: any) => x.gstibo_chart_type == 'Asidebox');
      this.commonService.ogLog('empasidebox', this.empasidebox);
      if (this.empasidebox.length == 0) {
        //let data = [{ gstibo_chart_heading: "Profile Details" }, { gstibo_chart_heading: "Absent Employee" }];
        let data = [{ gstibo_chart_heading: "Absent Employee" }];
        this.empasidebox = data;
      }
      if (this.empasidebox.length >= 1) {
        this.empasidebox = this.empasidebox.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock2');
        try {
          if (this.empasidebox[0].gstibo_chart_heading == 'Profile Details' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock2')
            this.empasidebox.push({ gstibo_chart_heading: "Profile Details" });
          if (this.empasidebox[0].gstibo_chart_heading == 'Absent Employee' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock2')
            this.empasidebox.push({ gstibo_chart_heading: "Absent Employee" });
        }
        catch (e) { }
      }

      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : ''),

      });
      this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);
      // user_Type_Name
      let chartQuery1;
      let accountUser = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
      if (accountUser.user_Type_Name == 'Admin') {
        chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_ProjectsTracked_employeewise order by gstibo_Month asc");
      }
      else {
        chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_ProjectsTracked_employeewise where gstibo_employee_id=" + this.commonService.getUserCredentials(KEYS.credential_account_id) + " order by gstibo_Month asc");
      }
      //const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_dashboard_departmentwiseexpense");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_LeaveComposition_employeewise where gstibo_employee_id=" + this.commonService.getUserCredentials(KEYS.credential_account_id));
      forkJoin([chartQuery1, chartQuery3]).subscribe((qdata: any) => {
        
        let chData1 = [];
        let chData2 = [];
        let chData3 = [];
        //console.log('qdata : ', qdata);
        if ((qdata[0]['table']) && (qdata[0]['table'].length > 0)) {
          let myData = [];
          chartColumns1 = ['Month', 'Hours'];
          //console.log('myData:', myData);
          //console.log('qdata[0]', qdata[0]['table']);
          if (this.defaultEmpProjectId == '0') {
            let myMap = new Map();
            let allData = [];
            qdata[0]['table'].forEach((element1: any) => {
              if (myMap.has(this.month[element1.gstibo_Month])) {
                let monVal = 0;
                monVal = myMap.get(this.month[element1.gstibo_Month])
                myMap.set(this.month[element1.gstibo_Month], element1.gstibo_NoOfProjects + monVal)
              } else {
                myMap.set(this.month[element1.gstibo_Month], element1.gstibo_NoOfProjects);
              }
            })

            this.commonService.ogLog(myMap, "myMap...................")
            allData = Array.from(myMap)
            this.commonService.ogLog(allData, "allData...................")

            chData1 = allData;
          } else {
            const empPrjId = (qdata[0]['table']).filter((x: any) => x.gstibo_Projectid == this.defaultEmpProjectId);
            if (isPresent(empPrjId)) {
              empPrjId.forEach((element1: any) => {
                let chSubData1 = [];
                chSubData1.push(this.month[element1['gstibo_Month']]);
                chSubData1.push(element1['gstibo_NoOfProjects']);
                chData1.push(chSubData1);
              });
            } else {
              let chSubData1 = [];
              chartColumns1 = ['Month', 'Hours'];
              chSubData1.push(this.month[1]);
              chSubData1.push(0);
              chData1.push(chSubData1);
            }

          }
          //console.log('chData1:', chData1);
          //console.log('data1:', qdata[0]['table']);
        } else {
          let myData = [];
          chartColumns1 = ['Month', 'Hours'];
          // console.log('myData:', myData);
          // qdata[0]['table'].forEach(element1 => {
          let chSubData1 = [];
          chSubData1.push(this.month[1]);
          chSubData1.push(0);
          chData1.push(chSubData1);
          // });
          // chData1 = null;
        }
        this.chartForm1.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock1,
          width: '100%',
          height: '16.7rem',
          data: chData1,
          columnNames: chartColumns1,
          colors: ['#8194AA', '#79b5fd', '#ff953b', '#ff3b5b']//['#08e3a3', '#6735f6', '#f28201', '#ff3b5b']
        });
        if ((qdata[1]['table']) && (qdata[1]['table'].length > 0)) {
          //this.commonService.ogLog('data3:', qdata[2]['table']);
          // if (this.defaultEmpLeaveProjectId == '0') {
          let myMap = new Map();
          let allData: any = [];
          let MainData = [];
          qdata[1]['table'].forEach((element3: any) => {
            if (myMap.has(this.month[element3.gstibo_Month])) {
              let myNewMap = new Map();
              myNewMap = myMap.get(this.month[element3.gstibo_Month]);
              myNewMap.set("casual", element3['gstibo_Casual'] + myNewMap.get("casual"));
              myNewMap.set("sick", element3['gstibo_Sick'] + myNewMap.get("sick"));
              myNewMap.set("Privilege", element3['gstibo_Privilege'] + myNewMap.get("Privilege"));
              myNewMap.set("holiday", element3['gstibo_Holiday'] + myNewMap.get("holiday"));
              myMap.set(this.month[element3.gstibo_Month], myNewMap);
              console.log('chartdata:', myMap);
            } else {
              let myNewMap = new Map();
              myNewMap.set("casual", element3['gstibo_Casual']);
              myNewMap.set("sick", element3['gstibo_Sick']);
              myNewMap.set("Privilege", element3['gstibo_Privilege']);
              myNewMap.set("holiday", element3['gstibo_Holiday']);
              myMap.set(this.month[element3.gstibo_Month], myNewMap);
            }
          })
          MainData = Array.from(myMap);
          MainData.forEach((map: any) => {
            let innerMap: any = Array.from(map[1]);
            let innerData = [];
            innerData.push(map[0]);
            innerData.push(innerMap[0][1]);
            innerData.push(innerMap[1][1]);
            innerData.push(innerMap[2][1]);
            innerData.push(innerMap[3][1]);
            allData.push(innerData);
            this.commonService.ogLog('alldata:', allData);
            // allData = ['Oct', 1, 1, 1];
          });
          //console.log(allData, "allData...................")
          chartColumns3 = ['Month', 'Casual', 'Sick', 'Privilege', 'Holiday'];
          chData3 = allData;
          //console.log(chData3, "chData3default0...................")

          //}
          // else {
          //   const empLeavePrjId = (qdata[1]['table']).filter(x => x.gstibo_Projectid == this.defaultEmpLeaveProjectId);
          //   if (isPresent(empLeavePrjId)) {
          //     empLeavePrjId.forEach(element3 => {
          //       let chSubData3 = [];
          //       chartColumns3 = ['Month', 'Casual', 'Sick', 'Privilege', 'Holiday'];
          //       chSubData3.push(this.month[element3['gstibo_Month']]);
          //       chSubData3.push(element3['gstibo_Casual']);
          //       chSubData3.push(element3['gstibo_Sick']);
          //       chSubData3.push(element3['gstibo_Privilege'])
          //       chSubData3.push(element3['gstibo_Holiday']);
          //       chData3.push(chSubData3);
          //       console.log('chData3:', chData3)
          //     });
          //   } else {
          //     let chSubData3 = [];
          //     chartColumns3 = ['Month', 'Casual', 'Sick', 'Privilege', 'Holiday'];
          //     chSubData3.push(this.month[1]);
          //     chSubData3.push(0);
          //     chSubData3.push(0);
          //     chSubData3.push(0);
          //     chData3.push(chSubData3);
          //   }
          //   //console.log(chData3, "chData3InprjId...................")
          // }

        } else {
          // qdata[2]['table'].forEach(element3 => {
          let chSubData3 = [];
          chartColumns3 = ['Month', 'Casual', 'Sick', 'Privilege', 'Holiday'];
          chSubData3.push(this.month[1]);
          chSubData3.push(0);
          chSubData3.push(0);
          chSubData3.push(0);
          chData3.push(chSubData3);
          // });
          //chData3 = null;
        }
        this.chartForm3.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock3,
          width: '100%',
          height: '16.7rem',
          data: chData3,
          columnNames: chartColumns3,
          colors: ['#cb9606', '#be0285', '#f28201', '#ff3b5b']
        });

        this.empasidebox1 = this.dashboardTemplateForm.value.emp_asideblock1
        this.empasidebox2 = this.dashboardTemplateForm.value.emp_asideblock2
        this.commonService.ogLog('this.empasidebox1', this.empasidebox1);
        this.commonService.ogLog('this.empasidebox2', this.empasidebox2);
      }, error => {
        console.log('forkjoin error');
      });
    });
    this.commonService.employeeMgmtDashboardProjectPresent.subscribe((val: any) => {
      this.isEmployeeMgmtDashboardProjectPresent = !!val;
      this.commonService.ogLog('this.isEmployeeMgmtDashboardProjectPresent:', this.isEmployeeMgmtDashboardProjectPresent);
    })
    this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);
  }

  loadTemplateseleven(dashboardId: string) {
    this.contactlist = [];
    this.commonService.getdashboardContactlist().subscribe((data: any) => {
      if (isPresent(data['table'])) {
        let data1 = data['table']
        this.contactlist = data['table'];
        console.log('Data:', data);
      }
    });

  }
  async loadTemplateTwentyOne() {
    this.commonService.getContactCountByType().subscribe((data: any) => {
      if (isPresent(data['table'])) {
        let data1 = data['table']
        this.commonService.ogLog('Contactlist Data By Type:', data1);
        this.contactCount = 0;
        this.customerCount = 0;
        this.vendorCount = 0;
        this.custVendorCount = 0;

        data1.forEach((item: any) => {
          switch (item?.gstibo_type) {
            case 'Contact':
              this.contactCount = item?.total_count;
              break;
            case 'Customer':
              this.customerCount = item?.total_count;
              break;
            case 'Vendor':
              this.vendorCount = item?.total_count;
              break;
            case 'Cust & Vendor':
              this.custVendorCount = item?.total_count;
              break;
          }
        })
      }
    });
  }
  async loadTemplatetwelve(dashboardId: string) {
    this.contactlist = [];
    this.chartFormcon = this.formBuilder.group({
      chartType: '',
      width: '100%',
      data: [],
      columnNames: [null],
      height: '',
      colors: [null],
      legendPosition: 'right',
      chartArea: {
        bottom: 10,
        right: 40,
        left: 20,
        top: 10

      }
    });
    this.commonService.getdashboardContactlist().subscribe((data: any) => {
      if (isPresent(data['table'])) {
        let data1 = data['table']
        this.contactlist = data['table'].map((element: any) => {
          return {
            ...element,
            gstibo_job_title: (element?.gstibo_job_title === null ||
              element?.gstibo_job_title === 'null' ||
              element?.gstibo_job_title === undefined) ? '' : element?.gstibo_job_title
          };
        });
        this.commonService.ogLog('Contactlist Data:', data);
      }
    });
    this.loadMeetingdetailsnew();
    this.getOutlookCalendarEvents();
    this.commonService.getdashboardContacttotalchart().subscribe((data: any) => {
      if (isData(data)) {
        this.commonService.ogLog('contacttotal:', data)
        let chData6: any = [];
        let chartColumns6 = ['Type', 'Percentage'];
        data['table'].forEach((element3: any) => {
          let chSubData6 = [];
          chSubData6.push(element3['contacttype']);
          chSubData6.push(element3['typepercentage']);
          //chSubData6.push(element3['gstibo_Actual']);
          chData6.push(chSubData6);
        });
        this.chartFormcon.patchValue({
          chartType: 'pieChart',
          width: '100%',
          height: '15rem',
          data: chData6,
          columnNames: chartColumns6,
          colors: ['#828125', '#d8b655', '#7a62ba', '#e4663f', '#4098d7',]
        });
        this.commonService.ogLog('chartFormcon:', this.chartFormcon)
      }
    })
    if (this.msAuthService.authenticated) {
      if (this.msAuthService.user) {
        await this.loadMails(this.msAuthService.user)
      } else {
        await this.loadMails(await this.msAuthService.getUser())
      }
    }

  }
  loadTemplatethirteen(dashboardId: string) {
    let chartColumns1 = [];
    let chartColumns2: any = [];
    let chartColumns3: any = [];
    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: [null],
      legendPosition: 'left'
    });
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: [null],
      chartArea: {}
    });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: [null]
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId);
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.empasidebox = dashboardChartData.filter((x: any) => x.gstibo_chart_type == 'Asidebox');
      this.commonService.ogLog('empasidebox', this.empasidebox);
      if (this.empasidebox.length == 0) {
        //let data = [{ gstibo_chart_heading: "Profile Details" }, { gstibo_chart_heading: "Absent Employee" }];
        let data = [{ gstibo_chart_heading: "Absent Employee" }];
        this.empasidebox = data;
      }
      if (this.empasidebox.length >= 1) {
        this.empasidebox = this.empasidebox.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock2');
        try {
          if (this.empasidebox[0].gstibo_chart_heading == 'Profile Details' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock2')
            this.empasidebox.push({ gstibo_chart_heading: "Profile Details" });
          if (this.empasidebox[0].gstibo_chart_heading == 'Absent Employee' && this.empasidebox[0].gstibo_chart_block_id == 'emp_asideblock2')
            this.empasidebox.push({ gstibo_chart_heading: "Absent Employee" });
        }
        catch (e) { }
      }

      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : ''),

      });
      this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);

      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_ProjectsTracked");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_dashboard_departmentwiseexpense");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_LeaveComposition");
      this.commonService.ogLog('chartquery2', chartQuery2);
      forkJoin([chartQuery1, chartQuery2, chartQuery3]).subscribe((qdata: any) => {
        
        let chData1 = [];
        let chData2 = [];
        let chData3 = [];
        //console.log('qdata : ', qdata);
        if ((qdata[0]['table']) && (qdata[0]['table'].length > 0)) {
          
          let myData = [];
          chartColumns1 = ['Month', 'Hours'];
          //console.log('myData:', myData);
          //console.log('qdata[0]', qdata[0]['table']);
          if (this.defaultEmpProjectId == '0') {
            let myMap = new Map();
            let allData = [];
            qdata[0]['table'].forEach((element1: any) => {
              if (myMap.has(this.month[element1.gstibo_Month])) {
                let monVal = 0;
                monVal = myMap.get(this.month[element1.gstibo_Month])
                myMap.set(this.month[element1.gstibo_Month], element1.gstibo_NoOfProjects + monVal)
              } else {
                myMap.set(this.month[element1.gstibo_Month], element1.gstibo_NoOfProjects);
              }
            })

            this.commonService.ogLog(myMap, "myMap...................")
            allData = Array.from(myMap)
            this.commonService.ogLog(allData, "allData...................")

            chData1 = allData;
          } else {
            const empPrjId = (qdata[0]['table']).filter((x: any) => x.gstibo_Projectid == this.defaultEmpProjectId);
            if (isPresent(empPrjId)) {
              empPrjId.forEach((element1: any) => {
                let chSubData1 = [];
                chSubData1.push(this.month[element1['gstibo_Month']]);
                chSubData1.push(element1['gstibo_NoOfProjects']);
                chData1.push(chSubData1);
              });
            } else {
              let chSubData1 = [];
              chartColumns1 = ['Month', 'Hours'];
              chSubData1.push(this.month[1]);
              chSubData1.push(0);
              chData1.push(chSubData1);
            }

          }
          //console.log('chData1:', chData1);
          //console.log('data1:', qdata[0]['table']);
        } else {
          let myData = [];
          chartColumns1 = ['Month', 'Hours'];
          // console.log('myData:', myData);
          // qdata[0]['table'].forEach(element1 => {
          let chSubData1 = [];
          chSubData1.push(this.month[1]);
          chSubData1.push(0);
          chData1.push(chSubData1);
          // });
          // chData1 = null;
        }
        this.chartForm1.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock1,
          width: '100%',
          height: '16.7rem',
          data: chData1,
          columnNames: chartColumns1,
          legendPosition: 'bottom',
          colors: ['#8195a9', '#bfcad5', '#ff953b', '#ff3b5b']//['#0177ff', '#79b5fd', '#ff953b', '#ff3b5b']['#08e3a3', '#6735f6', '#f28201', '#ff3b5b']
        });
        if ((qdata[1]['table']) && (qdata[1]['table'].length > 0)) {
          // chartColumns2 = ['Men', 'Women']
          // chSubData2.push('Men');
          // chSubData2.push(qdata[1]['table'][0]['gstibo_Men']);
          // chData2.push(chSubData2);
          // chSubData2 = [];
          // chSubData2.push('Women');
          // chSubData2.push(qdata[1]['table'][0]['gstibo_Women']);
          // chData2.push(chSubData2);
          let total = 0;
          qdata[1]['table'].forEach((element2: any) => {
            let chSubData2 = [];
            chartColumns2.push(element2.gstibo_DeptName);
            chSubData2.push(element2.gstibo_DeptName);
            chSubData2.push(element2.gstibo_ExpenseValue);
            chData2.push(chSubData2);
            total += Number(element2.gstibo_ExpenseValue);
          });
          this.totalEmpCnt = total.toString();
        } else {
          
          let chSubData2 = [];
          chartColumns2 = ['', '']
          chSubData2.push('');
          chSubData2.push(0);
          chData2.push(chSubData2);
          chSubData2 = [];
          chSubData2.push('');
          chSubData2.push(0);
          chData2.push(chSubData2);
          this.totalEmpCnt = '0';
          //chData2 = null;
        }
        this.chartForm2.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock2,
          // width: '100%',
          height: '16.7rem',
          data: chData2,
          columnNames: chartColumns2,
          colors: ['#f28202', '#f908b6', '#ff953b', '#ff3b5b'],
          chartArea: {
            bottom: 20,
            left: 0,
            right: 0,
            top: 20
          }
        });
        if ((qdata[2]['table']) && (qdata[2]['table'].length > 0)) {
          
          //console.log('data3:', qdata[2]['table']);
          if (this.defaultEmpLeaveProjectId == '0') {
            let myMap = new Map();
            let allData: any = [];
            let MainData = [];
            qdata[2]['table'].forEach((element3: any) => {
              if (myMap.has(this.month[element3.gstibo_Month])) {
                let myNewMap = new Map();
                myNewMap = myMap.get(this.month[element3.gstibo_Month]);
                myNewMap.set("casual", element3['gstibo_Casual'] + myNewMap.get("casual"));
                myNewMap.set("sick", element3['gstibo_Sick'] + myNewMap.get("sick"));
                myNewMap.set("holiday", element3['gstibo_Holiday'] + myNewMap.get("holiday"));

                myMap.set(this.month[element3.gstibo_Month], myNewMap);
              } else {
                let myNewMap = new Map();
                myNewMap.set("casual", element3['gstibo_Casual']);
                myNewMap.set("sick", element3['gstibo_Sick']);
                myNewMap.set("holiday", element3['gstibo_Holiday'])
                myMap.set(this.month[element3.gstibo_Month], myNewMap);
              }
            })
            MainData = Array.from(myMap);
            MainData.forEach((map: any) => {
              let innerMap: any = Array.from(map[1]);
              let innerData = [];
              innerData.push(map[0]);
              innerData.push(innerMap[0][1]);
              innerData.push(innerMap[1][1]);
              innerData.push(innerMap[2][1]);
              allData.push(innerData);
              // allData = ['Oct', 1, 1, 1];
            });
            //console.log(allData, "allData...................")
            chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
            chData3 = allData;
            //console.log(chData3, "chData3default0...................")

          }
          else {
            const empLeavePrjId = (qdata[2]['table']).filter((x: any) => x.gstibo_Projectid == this.defaultEmpLeaveProjectId);
            if (isPresent(empLeavePrjId)) {
              empLeavePrjId.forEach((element3: any) => {
                let chSubData3 = [];
                chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
                chSubData3.push(this.month[element3['gstibo_Month']]);
                chSubData3.push(element3['gstibo_Casual']);
                chSubData3.push(element3['gstibo_Sick']);
                chSubData3.push(element3['gstibo_Holiday']);
                chData3.push(chSubData3);
              });
            } else {
              let chSubData3 = [];
              chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
              chSubData3.push(this.month[1]);
              chSubData3.push(0);
              chSubData3.push(0);
              chSubData3.push(0);
              chData3.push(chSubData3);
            }
            //console.log(chData3, "chData3InprjId...................")
          }

        } else {
          // qdata[2]['table'].forEach(element3 => {
          let chSubData3 = [];
          chartColumns3 = ['Month', 'Casual', 'Sick', 'Holiday'];
          chSubData3.push(this.month[1]);
          chSubData3.push(0);
          chSubData3.push(0);
          chSubData3.push(0);
          chData3.push(chSubData3);
          // });
          //chData3 = null;
        }
        this.chartForm3.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock3,
          width: '100%',
          height: '16.7rem',
          data: chData3,
          columnNames: chartColumns3,
          colors: ['#bdafe0', '#9d89ce', '#a395c6', '#ff3b5b']//['#08e3a3', '#6735f6', '#f28201', '#ff3b5b']
        });

        this.empasidebox1 = this.dashboardTemplateForm.value.emp_asideblock1
        this.empasidebox2 = this.dashboardTemplateForm.value.emp_asideblock2
        this.commonService.ogLog('this.empasidebox1', this.empasidebox1);
        this.commonService.ogLog('this.empasidebox2', this.empasidebox2);
      }, error => {
        console.log('forkjoin error');
      });

    });

    this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);
  }
  async loadTemplatefourteen(dashboardId: string) {
    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      legendPosition: 'bottom',
      bargroupwidth: '',
      colors: [],
      chartArea: {},
      legendMaxLine: '',
      bars: '',
      barPercentage: 0.2,
      bar: '',
      // barPercentage:  4, 
    });
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      pieHole: '',
      legendPosition: '',
      color: []
    });
    this.chartForm4 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm5 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm6 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      bar: 'horizontal',
      hAxis: { title: 'Days' },
      legendPosition: 'bottom',
      color: []
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId);
    if (this.msAuthService.authenticated) {
      if (this.msAuthService.user) {
        await this.loadMails(this.msAuthService.user)
      } else {
        await this.loadMails(await this.msAuthService.getUser())
      }
    }
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('datafourteen : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock7: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock4Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        chartBlock5Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        chartBlock6Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_heading'] : ''),
        chartBlock7Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_heading'] : '')
      });
      this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm)
      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_OpenReqByDepartment");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_EfficiencyOfHiring order by gstibo_id asc");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_Recruitment order by gstibo_value desc");
      const chartQuery4 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_Turnover");
      const chartQuery5 = this.commonService.executedynamicquery("select * , '' color,'' colorbar from gstibo_dev_Dboard_rec_HiresBySource");
      const chartQuery6 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_HireByGrade ");
      const chartQuery7 = this.commonService.executedynamicquery("select * ,'' color from gstibo_dev_Dboard_rec_OfferDecline order by gstibo_item");
      const chartQuery8 = this.commonService.executedynamicquery("select * ,'' color from gtstibo_dev_Dboard_rec_Tiles");

      forkJoin([chartQuery1, chartQuery2, chartQuery3, chartQuery4, chartQuery5, chartQuery6, chartQuery7, chartQuery8]).subscribe((qdata: any[]) => {
        let chData1 = [];
        let chData2 = [];
        let chData3 = [];
        let chData4: any = [];
        let chData5 = [];
        let chData6 = [];
        let chData7 = [];
        let chart1Columns = [];
        let chart3Columns = [];
        let chart5Columns = [];
        let chart6Columns = [];
        chart1Columns = [];// ['Department', 'Percentage'];
        this.commonService.ogLog('qdata : ', ['Department', 'Percentage']);
        // let chSubData = [];
        // chSubData.push('Element');
        // chSubData.push('Density');
        // chSubData.push({ role: "style" });
        //chData1.push(chSubData);
        //"Element", "Density", { role: "style" }
        this.commonService.ogLog('qdata : ', qdata[0]['table'], qdata[5]['table'], qdata[4]['table']);
        chart1Columns = [];
        if ((qdata[0]['table']) && (qdata[0]['table'].length > 0)) {
          chart1Columns.push('dept');
          qdata[0]['table'].forEach((element1: any) => {
            let chSubData1 = [];
            chart1Columns.push(element1.gstibo_dept);
          });
          let chSubData1 = [];
          chSubData1.push('');
          qdata[0]['table'].forEach((element1: any) => {
            let chSubDataa1 = [];
            chSubData1.push(element1.gstibo_value);
          });
          chData1.push(chSubData1);

          // });


          // let chSubData1 = [];
          // chart1Columns.push('Dept','Hours');
          // let deptcnt =qdata[0]['table'].map(p => p.gstibo_dept) ;
          // let i=0;
          // deptcnt.forEach(element1 => {
          //   let chSubData1 = []; 
          //   chSubData1.push(deptcnt[i]);
          //   chSubData1.push(qdata[0]['table'].filter(g=>g.gstibo_dept == deptcnt[i])[0].gstibo_value);
          //   chData1.push(chSubData1);
          //   i=i+1;
          // });

          // chart1Columns=[];
          // chart1Columns.push(deptcnt);

          this.commonService.ogLog('chart1Columns:', chart1Columns);
          this.commonService.ogLog('chData1:', chData1);
          this.commonService.ogLog('data1:', qdata[0]['table']);
        } else {
          chData1 = [];
          let chSubData1 = [];
          chart1Columns = []
          chSubData1.push('0');
          chSubData1.push(0);
          chData1.push(chSubData1);
          // });
          //chData1 = null;
        }
        let colors = ['#deb887', '#d6dac8', '#f1ef99', '#c5ebaa', '#ffefdf', '#d2691e', '#cd853f', '#f0e68c', '#5f9ea0', '#87ceeb'];// ['#525be4', '#9c52fd', '#ef0c51', '#24e4ab', '#ef0c51', '#24e4ab'];
        if (chData1.length > 0) {
          this.chartForm1.patchValue({
            chartType: 'barChart',
            width: '100%',
            height: '21rem',
            data: chData1,
            columnNames: chart1Columns,
            colors: colors,
            legendPosition: 'bottom',
            legend: { position: 'bottom', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
            bar: "70%",//requisition 
            bargroupwidth: '5',
            legendMaxLine: '5',
            chartArea: {
              bottom: 20,
              right: 10,
              left: 10,
              top: 20,
              width: '150px'
            },
            barPercentage: 0.2,
          });
          this.commonService.ogLog('this.chartForm1', this.chartForm1);
          this.commonService.ogLog('this.chartForm1', chData1, chart1Columns);

        }
        if (qdata[1]['table']) {
          this.roundChartEffHiring = qdata[1]['table'];
          let total = 0;

          if ((qdata[1]['table']) && (qdata[1]['table'].length > 0)) {
            qdata[1]['table'].forEach((element2: any) => {
              let chSubData3 = [];
              total += Number(element2.gstibo_value);
              chart3Columns.push(element2.gstibo_Item);
              chSubData3.push(element2.gstibo_Item);
              chSubData3.push(element2.gstibo_value);
              chData3.push(chSubData3);
            });
          }
          else {
            let chSubData3 = [];
            chart3Columns.push('0');
            chSubData3.push('0');
            chSubData3.push('0');
            chData3.push(chSubData3);
          }
          this.commonService.ogLog('chData3', chData3);
          this.totalEHValue = total.toString();
          this.commonService.ogLog('this.roundChartEffHiring', this.roundChartEffHiring)
          this.chartForm3.patchValue({
            chartType: this.dashboardTemplateForm.value.chartBlock2,
            width: '31rem',
            height: '20rem',
            data: chData3,
            columnNames: chart3Columns,
            legendPosition: 'right',
            pieHole: '0.1',
            chartArea: {
              bottom: 0,
              right: 0,
              left: 0,
              top: 20

            }
          });
        }
        if (qdata[2]['table']) {
          this.commonService.ogLog('data3:', qdata[2]['table']);
          this.recruitmentFunnel = qdata[2]['table'];
        }
        if (qdata[3]['table']) {
          qdata[3]['table'].forEach((element1: any) => {
            let chSubData4 = [];
            chSubData4.push(element1.gstibo_year);
            chSubData4.push(element1.gstibo_value1);
            chSubData4.push(element1.gstibo_value1);
            chSubData4.push(element1.gstibo_value1);
            chData4.push(chSubData4);
          });
          this.commonService.ogLog('chData4:', chData4);
        } else {
          chData4 = null;
        }
        this.chartForm4.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock4,
          width: '100%',
          height: '20rem',
          data: chData4,
          columnNames: ['Year', 'Value1', 'Value2', 'Value3']
        });
        this.recuirtmentnewhire = qdata[4]['table'];
        this.commonService.ogLog('qdata[4]:', qdata[4]['table']);
        if ((qdata[4]['table']) && (qdata[4]['table'].length > 0)) {
          for (let i = 0; i < this.recuirtmentnewhire.length; i++) {
            chart5Columns.push({ "name": this.recuirtmentnewhire[i].gstibo_Item, "color": this.recuritmenthirecoloredArray[i] });
          }
          for (let i = 0; i < this.recuirtmentnewhire.length; i++) {
            chData5.push({ "name": this.recuirtmentnewhire[i].gstibo_Item, "value": this.recuirtmentnewhire[i].gstibo_value, "color": this.recuritmenthirbarecoloredArray[i] });//
          }
          qdata[4]['table'].forEach((element1: any) => {
            let chSubData5 = [];
            //chart5Columns.push(element1.gstibo_Item);
            chSubData5.push(element1.gstibo_Item);
            chSubData5.push(element1.gstibo_value);
            chData5.push(chSubData5);
          });
          this.commonService.ogLog('chart5Columns:', chart5Columns);
          this.commonService.ogLog('data5:', qdata[4]['table']);
        } else {
          let chSubData5 = [];
          chart5Columns.push('0');
          chSubData5.push('0');
          chSubData5.push('0');
          chData5.push(chSubData5);
          //chData5 = null;
        }
        this.commonService.ogLog('chData5', chData5);
        this.chartForm5.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock5,
          // width: '100%',
          height: '20rem',
          data: chData5,
          columnNames: chart5Columns,
          legendPosition: 'bottom'
        });
        // this.commonService.ogLog('chData5', this.chartForm5.controls.data.value);
        //qdata[5] time to hire bygrades




        ///////////////////////////////////////

        let chSubData6 = [];
        if ((qdata[5]['table']) && (qdata[5]['table'].length > 0)) {
          // chData6.push(['Category','Count','week'])
          chData6 = [];
          chart6Columns = ['Name', 'Days'];
          qdata[5]['table'].forEach((element1: any) => {
            let chSubData6 = [];
            let valueofweek = element1.gstibo_value == null ? 0 : element1.gstibo_value;
            if (valueofweek == 0) {
              element1.gstibo_cnt = 0;
            }
            let countasint: Number = element1.gstibo_cnt;
            chSubData6.push(element1.gstibo_item, valueofweek);

            chData6.push(chSubData6);
          });
          this.commonService.ogLog('chart1Columns:', chart6Columns);
        }
        else {
          chData6 = [];
          let chSubData6 = [];
          chart6Columns = ['Name', 'Days'];
          chSubData6.push('0');
          chSubData6.push('0');
          chData6.push(chSubData6);

        }

        if (chData6.length > 0) {
          this.chartForm6.patchValue({
            chartType: this.dashboardTemplateForm.value.chartBlock1,
            width: '100%',
            height: '18rem',
            data: chData6,
            columnNames: chart6Columns,
            legend: { position: 'left', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
            bars: 'horizontal',
            chartArea: {
              bottom: 40,
              right: 20,
              left: 100,
              top: 20

            },
            hAxis: { title: 'Days' },
            colors: ['#FFB8CD', '#A9FFE6'],
            bargroupwidth: "5%",
            barPercentage: 0.4,
          });
          this.commonService.ogLog('this.chartForm6', this.chartForm6);
        }
        else {
          chData6 = [];
          let chSubData6 = [];
          chart6Columns = ['Name', 'Day', 'Count'];
          chSubData6.push('0');
          chSubData6.push('0');
          chData6.push(chSubData6);

        }




        // chart6 end
        //
        this.DealProgressColoredArray = ["bars", "bars blue", "bars pink", "bars green", "bars violet"];
        if (qdata[6]['table']) {
          this.offerDecline = [];
          this.offerDecline = qdata[6]['table'];
          for (let i = 0; i < this.offerDecline.length; i++) {
            this.offerDecline[i].color = this.DealProgressColoredArray[i];
            // this.offerDecline.push({"gstibo_Item":this.offerDecline[i].gstibo_Item,"gstibo_value":this.recuirtmentnewhire[i].gstibo_value,
            // "color":this.DealProgressColoredArray[i],"gstibo_per":this.offerDecline[i].gstibo_Item});//
          }
          this.commonService.ogLog('chData7:', qdata[6]['table']);
        }
        if (qdata[7]['table']) {
          this.recruirtmenttiles = qdata[7]['table'];
        }
      }, error => {
        console.log('forkjoin error');
      });

    });

    this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);

  }
  async loadTemplatefifteen(dashboardId: string) {

    this.stageTableData = [
      { opId: 'OP-513521', agency: 'Airforce', stage: 'Feasibility Analysis' },
      { opId: 'OP-513520', agency: 'Army', stage: 'Proposal Management' },
      { opId: 'OP-513521', agency: 'DHA', stage: 'Award Management' },
      { opId: 'OP-513522', agency: 'Dept.of Energy (DOE)', stage: 'Opportunity' },
      { opId: 'OP-513523', agency: 'Army', stage: 'Proposal Management' },
      { opId: 'OP-513524', agency: 'Airforce', stage: 'Feasibility Analysis' }
    ];

    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      legendPosition: 'bottom',

    });
    // this.chartForm2 = this.formBuilder.group({
    //   chartType: null,
    //   width: '',
    //   data: [null],
    //   columnNames: [null],
    //   height: '',
    //   bar: '',
    //   colors: '',
    //   chartArea: {},
    //   legendPosition:'none'
    // });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: '',
      chartArea: {}
    });
    this.chartForm4 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: '',
      chartArea: {}
    });
    this.chartForm5 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: '',
      chartArea: {},
      legendPosition: 'bottom',
      bargroupwidth: '',
      legendMaxLine: '',
      bar: '',
    });
    this.chartForm6 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId, this.msAuthService.authenticated, this.msAuthService.user);
    if (this.msAuthService.authenticated) {
      if (this.msAuthService.user) {
        await this.loadMails(this.msAuthService.user)
      } else {
        await this.loadMails(await this.msAuthService.getUser())
      }
    }
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock7: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock4Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        chartBlock5Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        chartBlock6Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_heading'] : ''),
        chartBlock7Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_heading'] : '')
      });
      this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm)
      const chartQuery0 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Opportunity_Tiles");
      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_opportunity_revenueclosed");
      //const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_opportunity_deal_lost_won");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_opportunity_Funnel");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Opportunity_Tiles");
      // const chartQuery4 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Top10_Open_Opportunity");
      const chartQuery4 = this.commonService.executedynamicquery("select top 10 * from gstibo_dev_Dboard_Top_10_opportunity_status");
      const chartQuery5 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Top10_Won_Opportunity");
      const chartQuery6 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Opportunity_Campaign_Type");
      const chartQuery7 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Opportunity_Revenu_month");
      //const chartQuery8 = this.commonService.executedynamicquery("select * from gtstibo_dev_Dboard_Opportunity_TaskComplition");
      const chartQuery8 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_opportunity_winratio");

      // New Procurement Dashboard SPs
      const chartQuery9 = this.commonService.executedynamicquery("exec usp_get_total_revenue_by_quarter");
      const chartQuery10 = this.commonService.executedynamicquery("exec usp_top_five_proposal_owners_last_three_months");
      const chartQuery11 = this.commonService.executedynamicquery("exec usp_opportunity_by_stage_summary");
      const chartQuery12 = this.commonService.executedynamicquery("exec usp_get_opportunity_type_count");
      const chartQuery13 = this.commonService.executedynamicquery("exec usp_total_number_of_approved_proposals");
      const chartQuery14 = this.commonService.executedynamicquery("exec usp_monthly_awards_vs_submissions_last_five_years");
      const chartQuery15 = this.commonService.executedynamicquery("exec usp_dashboard_quarterly_summary");

      forkJoin([chartQuery0, chartQuery1, chartQuery2, chartQuery3, chartQuery4, chartQuery5, chartQuery6, chartQuery7, chartQuery8,
        chartQuery9, chartQuery10, chartQuery11, chartQuery12, chartQuery13, chartQuery14, chartQuery15]).subscribe((qdata: any[]) => {
          let chData1: any[] = [];
          let chData2: any[] = [];
          let chData3: any[] = [];
          let chData4: any[] = [];
          let chData6: any[] = [];
          let chData7: any[] = [];
          let chart1Columns: any[] = [];
          let chart3Columns: any[] = [];
          let chart4Columns: any[] = [];
          let chart6Columns: any[] = [];
          this.commonService.ogLog('qdata : ', qdata);
          if (qdata[0]['table']) {
            this.leadTiles = qdata[0]['table'];
          }
          if ((qdata[1]['table']) && (qdata[1]['table'].length > 0)) {
            qdata[1]['table'].forEach((element1: any) => {
              let chSubData1 = [];
              const val = qdata[1]['table'][0]['gstibo_value'];
              chData1 = [
                ['Value', val]
              ];
            });
            this.commonService.ogLog('chData1:', chData1);
            this.commonService.ogLog('data1:', qdata[1]['table']);
          } else {
            let chSubData1 = [];
            chart1Columns.push('0');
            chSubData1.push('0');
            chSubData1.push('0');
            chData1.push(chSubData1);
          }
          this.chartForm1.patchValue({
            chartType: this.dashboardTemplateForm.value.chartBlock1,
            width: '100%',
            height: '25rem',
            data: chData1,
            columnNames: chart1Columns,
            legendPosition: 'bottom',

          });
          let chSubData1 = [];
          if (qdata[2]['table']) {
            chart1Columns = ['Name', 'Total', { role: 'style' }];
            let coloarr = ['#5DADE2', '#48C9B0', '#58D68D', '#F4D03F', '#EB984E', '#27AE60']
            const tbl1 = (qdata[2]['table']).filter((x: any) => x.gstibo_quarter == this.funnelquarter);
            if (isPresent(tbl1)) {
              let i = 0;
              tbl1.forEach((element1: any) => {
                chSubData1 = [];
                chSubData1.push(' ' + element1.gstibo_name);
                chSubData1.push(element1.gstibo_opportunity_count);
                chSubData1.push(coloarr[i]);
                chData2.push(chSubData1);
                i++;
                this.funnelchart = chSubData1;
              });
            }
            else
              this.funnelchart = [];
          }
          else {
            this.funnelchart = [];
            // chart1Columns = ['Name', ''];
            // chSubData1 = [];
            // chSubData1.push('');
            // chSubData1.push(0);
            // //chSubData1.push(0);
            // chData2.push(chSubData1);

          }
          this.commonService.ogLog('Deal chart data : ', chData2);
          // this.chartForm2.patchValue({
          //   chartType: this.dashboardTemplateForm.value.chartBlock2,
          //   width: '100%',
          //   height: '20rem',
          //   data: chData2,
          //   columnNames: chart1Columns,
          //   legendPosition: 'none',
          //   bar: 'vertical',
          //   //colors: ['#97c1bc', '#90c9ff'],
          //   chartArea: {
          //     bottom:50,
          //     right: 20,
          //     left: 20,
          //     top: 20

          //   },
          // });
          if ((qdata[4]['table']) && (qdata[4]['table'].length > 0)) {
            this.top10Opportunity = qdata[4]['table'];
          }
          if ((qdata[5]['table']) && (qdata[5]['table'].length > 0)) {
            this.top10wonOpportunity = qdata[5]['table'];
          }
          if (qdata[6]['table']) {
            this.commonService.ogLog('chData7:', qdata[6]['table']);
            qdata[6]['table'].forEach((element2: any) => {
              let chSubData2 = [];
              chart3Columns.push(element2.gstibo_Campaign_Name);
              chSubData2.push(element2.gstibo_Campaign_Name);
              chSubData2.push(element2.gstibo_per);
              chData3.push(chSubData2);
            });
          } else {
            let chSubData2 = [];
            chart3Columns = ['', '']
            chSubData2.push('');
            chSubData2.push(0);
            chData2.push(chSubData2);
            chSubData2 = [];
            chSubData2.push('');
            chSubData2.push(0);
            chData3.push(chSubData2);

          }
          this.chartForm3.patchValue({
            chartType: this.dashboardTemplateForm.value.chartBlock3,
            width: '100%',
            height: '20rem',
            data: chData3,
            columnNames: ['Item', 'Value'],
            colors: ['#2D99FE', '#FF4D8E', '#826BFA', '#2CD9C5', '#FF6C40'],
            chartArea: {
              bottom: 20,
              right: 20,
              left: 20,
              top: 20

            },
          });
          let chSubData3 = [];
          if (qdata[7]['table']) {

            chart6Columns = ['Month', 'Value'];
            qdata[7]['table'].forEach((element1: any) => {
              chSubData3 = [];
              chSubData3.push(element1.gstibo_Month_Name);
              chSubData3.push(element1.gstibo_per);
              chData7.push(chSubData3);
            });
          }
          else {
            chart6Columns = ['Month', 'Value'];
            chSubData3 = [];
            chSubData3.push('');
            chSubData3.push(0);
            chData7.push(chSubData3);
          }
          this.commonService.ogLog('estimated chart data : ', chData7);
          this.chartForm4.patchValue({
            chartType: this.dashboardTemplateForm.value.chartBlock4,
            data: chData7,
            columnNames: chart6Columns,
            legendPosition: 'bottom',
            bar: 'horizontal',
            colors: ['#19C792', '#F94350'],
            chartArea: {
              bottom: 20,
              right: 20,
              left: 20,
              top: 20

            },
          });
          let chSubData4 = [];
          if (qdata[8]['table']) {
            chart4Columns = ['Name', 'Count'];
            const tbl1 = (qdata[8]['table']).filter((x: any) => x.gstibo_quarter == this.winQuarter);
            if (isPresent(tbl1)) {
              tbl1.forEach((element1: any) => {
                chSubData4 = [];
                chSubData4.push(' ' + element1.gstibo_name);
                chSubData4.push(element1.gstibo_count);
                //chSubData1.push(element1.gstibo_dealwon);
                chData4.push(chSubData4);
                this.winRatioChart = chSubData4;
              });
            } else {
              this.winRatioChart = [];
            }
          }
          if (qdata[9]['table']) {
            this.commonService.ogLog("Total Reveneu", qdata[9]['table'][0]);
            this.quarterRevenue = {
              Q1: qdata[9]['table'][0]?.total_quarter1,
              Q2: qdata[9]['table'][0]?.total_quarter2,
              Q3: qdata[9]['table'][0]?.total_quarter3,
              Q4: qdata[9]['table'][0]?.total_quarter4,
            }
            this.updateRevenue();
          }
          if (qdata[10]['table']) {
            this.commonService.ogLog("Top 5 Proposal Owners", qdata[10]['table']);
          }
          if (qdata[11]['table']) {
            this.commonService.ogLog("Opportunity By Stage Summary", qdata[11]['table']);
            qdata[11]['table']?.forEach((item: any) => {
              this.stageSummaryMap[item?.stage_label] = item?.stage_count;
            })
          }
          if (qdata[12]['table']) {
            this.commonService.ogLog("Opportunity Type Count", qdata[12]['table']);
          }
          if (qdata[13]['table']) {
            this.totalProposalApprovedCount = qdata[13]['table'][0]?.total_count;
            this.commonService.ogLog("Total Number of Approved Proposals", qdata[13]['table'][0]?.total_count);
          }
          if (qdata[14]['table']) {
            this.commonService.ogLog("Monthly Awards vs Submissions last 5 years", qdata[14]['table']);
          }
          if (qdata[15]['table']) {
            this.commonService.ogLog("Dashboard Quarterly Summary", qdata[15]['table']);
          }
          else {
            chart4Columns = ['Opportunity', ''];
            chSubData4 = [];
            chSubData4.push(chart4Columns);
            chart4Columns = ['Awareded', ''];
            chSubData4.push(chart4Columns);

            chSubData4.push(0);
            //chSubData1.push(0);
            chData2.push(chSubData4);
            this.winRatioChart = [];
          }
          this.commonService.ogLog('Deal chart data1 : ', chData4);
          this.commonService.ogLog('Deal chart data1 : ', chSubData4);

          chart4Columns = ["", ...chData4.map((item: any) => item[0].trim())];
          const transformedChData4 = [
            ["", ...chData4.map((item: any) => item[1])]
          ];

          this.chartForm5.patchValue({
            chartType: 'barChart',
            width: '100%',
            height: '16rem',
            data: transformedChData4,
            columnNames: chart4Columns,
            legendPosition: 'bottom',
            legend: { position: 'bottom', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
            bar: 'vertical',
            colors: ['#2c6fbb', '#2dba8d'],
            chartArea: {
              bottom: 40,
              right: 20,
              left: 20,
              top: 20
            },
          });

        }, error => {
          console.log('forkjoin error');
        });

    });


    this.commonService.ogLog('this.dashboardTemplateForm:', this.chartForm5);

    this.commonService.ogLog('this.dashboardTemplateForm:chart 5', this.chartForm5);

    let donutData = [
      ['GovCon', 22],
      ['Commercial', 38],
      ['Public Sector', 18],
      ['Service Sector', 22]
    ];

    let donutColumns = ['Type', 'Count'];

    this.chartFormDonut = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });

    this.chartFormDonut.patchValue({
      chartType: 'donutChart',
      width: '100%',
      height: '18rem',
      data: donutData,
      columnNames: donutColumns,
      chartclick: false
    });

    let lineData = [
      ['Feb', 12, 20],
      ['Mar', 18, 24],
      ['Apr', 22, 26],
      ['May', 21, 25],
      ['Jun', 24, 30],
      ['Jul', 23, 28],
      ['Aug', 26, 31],
      ['Sep', 22, 27],
      ['Oct', 24, 29],
      ['Nov', 23, 26],
      ['Dec', 28, 33]
    ];

    let lineColumns = ['Month', 'Awards', 'Submissions'];

    this.chartFormLineTrend = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });

    this.chartFormLineTrend.patchValue({
      chartType: 'lineChart',
      width: '100%',
      height: '20rem',
      data: lineData,
      columnNames: lineColumns,
      chartclick: false,
      isProcurementDashboard: true
    });
  }

  updateRevenue() {
    this.totalRevenue = this.quarterRevenue[this.selectedRevenueQuarter] || 0;
  }

  getRowClass(stage: string) {
    return {
      'row-feasibility': stage === 'Feasibility Analysis',
      'row-proposal': stage === 'Proposal Management',
      'row-award': stage === 'Award Management',
      'row-opportunity': stage === 'Opportunity'
    };
  }

  getPillClass(stage: string) {
    return {
      'pill-feasibility': stage === 'Feasibility Analysis',
      'pill-proposal': stage === 'Proposal Management',
      'pill-award': stage === 'Award Management',
      'pill-opportunity': stage === 'Opportunity'
    };
  }

  loadTemplateSIXTEEN(dashboardId: string) {
    let chartColumns2 = [];
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: []
    });

    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        crmCB1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1'))[0]['gstibo_chart_type'] : ''),
        crmCB2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2'))[0]['gstibo_chart_type'] : ''),
        crmCB3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3'))[0]['gstibo_chart_type'] : ''),
        crmCB4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4'))[0]['gstibo_chart_type'] : ''),
        crmCB5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5'))[0]['gstibo_chart_type'] : ''),
        crmCB6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crmChartBlock6'))[0]['gstiboChartType'] : ''),
        crmCB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        crmCB2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        crmCB3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        crmCB4Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        crmCB5Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        crmCB6Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crmChartBlock6'))[0]['gstiboChartHeading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_staticBlock1'))[0]['gstibo_chart_heading'] : '')
      });
      console.log('dashboardTemplateForm : ', this.dashboardTemplateForm);
      const chartQuery1 = this.commonService.executedynamicquery("select * ,concat(perc,'%') as per,'' colors from gstibo_dev_Dboard_CRM_DealsProgressByCount order by tbl_id asc");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_CountOfLeads");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_Deals");
      const chartQuery4 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_LeadConversationAnalytics");
      const chartQuery5 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_TotalValueConverted");
      const chartQuery6 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_BudgetVsActual");
      const chartQuery7 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_CRM_Tiles order by gstibo_id asc");
      const chartQuery8 = this.commonService.executedynamicquery("select Top 5* from gstibo_dev_Dboard_CRM_Top_Items order by gstibo_id asc");
      forkJoin(
        [
          chartQuery1, chartQuery2, chartQuery3,
          chartQuery4, chartQuery5, chartQuery6,
          chartQuery7, chartQuery8
        ]
      ).subscribe((qdata: any[]) => {
        let chData1 = [];
        let chData2 = [];
        let chData3 = [];
        let chData4 = [];
        let chData5 = [];
        let chData6 = [];
        this.commonService.ogLog('qdata : ', qdata);
        if (qdata[0]['table']) {
          let colorarr = ['#ffd19f', '#f4aaa1', '#ad8fd7', '#aeb9f7', '#a8dab4', '#ffd19f', '#f4aaa1', '#ad8fd7', '#aeb9f7', '#a8dab4']
          this.dealsProgress = qdata[0]['table'];
          for (let i = 0; i < this.dealsProgress.length; i++) {
            this.dealsProgress[i].colors = colorarr[i];
          }

        }
        if ((qdata[1]['table']) && qdata[1]['table'].length > 0) {
          let value1 = [];
          let value2 = [];
          let value3 = [];
          value1.push('Leads Created');
          value2.push('Proposal Made');
          value3.push('Closed the deal');
          chartColumns2.push('Items');
          qdata[1]['table'].forEach((element3: any) => {
            value1.push(element3['gstibo_Value1']);
            value2.push(element3['gstibo_Value2']);
            value3.push(element3['gstibo_Value3']);
            chartColumns2.push(element3['gstibo_item']);
          });
          chData2.push(value1, value2, value3);
          this.commonService.ogLog('chData2 : ', chData2);
          this.chartForm2.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB2,
            //width: '100%',
            height: '19rem',
            data: chData2,
            columnNames: chartColumns2,
            colors: ['#bdafe0', '#bf6bc1'],
          });
          this.commonService.ogLog('chartForm2 : ', this.chartForm2);
        }
        else {
          let value1 = [];
          let value2 = [];
          let value3 = [];
          value1.push('Leads Created');
          value2.push('Proposal Made');
          value3.push('Closed the deal');
          chartColumns2.push('Items');
          value1.push(0);
          value2.push(0);
          value3.push(0);
          chartColumns2.push('');
          chData2.push(value1, value2, value3);
          this.chartForm2.patchValue({
            chartType: this.dashboardTemplateForm.value.crmCB2,
            //width: '100%',
            height: '19rem',
            data: chData2,
            columnNames: chartColumns2
          });
          this.commonService.ogLog('chartForm2 : ', this.chartForm2);
        }
        if (qdata[2]['table']) {
          this.dealsPivote = qdata[2]['table'];
        }
        if (qdata[3]['table']) {
          this.leadConversation = qdata[3]['table'];
          this.commonService.ogLog('this.leadConversation', this.leadConversation);
        } else {
          const leadSample = [{
            gstibo_created_value: 0,
            gstibo_converted_value: 0,
            gstibo_won_value: 0,
            gstibo_lost_value: 0,
            gstibo_created_per: 0,
            gstibo_converted_per: 0,
            gstibo_won_per: 0,
            gstibo_lost_per: 0
          }];
          this.leadConversation = leadSample;
        }

        if (qdata[6]['table']) {
          this.leadTiles = qdata[6]['table'];
        }
        if (qdata[7]['table']) {
          this.top5Deals = qdata[7]['table'];
          this.commonService.ogLog('top5Deals', this.top5Deals)
        }
      }, error => {
        console.log('forkjoin error');
      });
    }, error => {
      console.log('forkjoin error');
    });
  }

  loadTemplateSEVENTEEN(dashboardId: string) {
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    let chData2 = [
      ['Positive', 3],
      ['Negative', 2],
      ['Mixed', 5]];
    let chartColumns2 = ['Task', 'Hours per Day'];
    this.chartForm2.patchValue({
      chartType: 'donutChart',
      width: '100%',
      height: '25rem',
      data: chData2,
      columnNames: chartColumns2,
      chartclick: 'false'
    });
    this.commonService.ogLog('this.chartForm2:', this.chartForm2);
    this.getVendorOpportunityList();
    this.getvendorDocumentsList();
  }
  /////////////////////////////mcf dashboard/////////////////////////////////////
  loadTemplateeighteen(dashboardId: string) {
    this.admissionlist = [];
    this.chartFormcon = this.formBuilder.group({
      chartType: '',
      width: '100%',
      data: [],
      columnNames: [null],
      height: '',
      colors: [null]
    });
    this.commonService.getdashboardAdmissionlist().subscribe((data: any) => {
      if (isPresent(data['table'])) {
        let data1 = data['table']
        this.admissionlist = data['table'];
        this.commonService.ogLog('Data:', data);
      }
    });
    this.loadMeetingdetailsnew();
    this.getOutlookCalendarEvents();
    this.commonService.getdashboardContacttotalchart().subscribe((data: any) => {
      if (isData(data)) {
        this.commonService.ogLog('contacttotal:', data)
        let chData6: any[] = [];
        let chartColumns6 = ['Type', 'Percentage'];
        data['table'].forEach((element3: any) => {
          let chSubData6 = [];
          chSubData6.push(element3['contacttype']);
          chSubData6.push(element3['typepercentage']);
          //chSubData6.push(element3['gstibo_Actual']);
          chData6.push(chSubData6);
        });
        this.chartFormcon.patchValue({
          chartType: 'pieChart',
          width: '100%',
          height: '23rem',
          data: chData6,
          columnNames: chartColumns6,
          colors: ['#828125', '#d8b655', '#7a62ba', '#e4663f', '#4098d7',]
        });
        this.commonService.ogLog('chartFormcon:', this.chartFormcon)
      }
    })

  }
  async loadTemplatenineteen(dashboardId: string) {
    this.chartForm1 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      legendPosition: 'bottom',
      bargroupwidth: '',
      colors: [],
      chartArea: {},
      legendMaxLine: '',
      bars: '',
      barPercentage: 0.2,
      bar: '',
      // barPercentage:  4, 
    });
    this.chartForm2 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm3 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      pieHole: '',
      legendPosition: '',
      color: []
    });
    this.chartForm4 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm5 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: ''
    });
    this.chartForm6 = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      bar: 'horizontal',
      hAxis: { title: 'Days' },
      legendPosition: 'bottom',
      color: []
    });
    const defaultChart = '';
    this.commonService.ogLog('dashboardId:', dashboardId);
    if (this.msAuthService.authenticated) {
      if (this.msAuthService.user) {
        await this.loadMails(this.msAuthService.user)
      } else {
        await this.loadMails(await this.msAuthService.getUser())
      }
    }
    this.commonService.loadDashboardChartData('', dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('datafourteen : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        SB1Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock7: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock4Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        chartBlock5Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        chartBlock6Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_heading'] : ''),
        chartBlock7Title: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_heading'] : '')
      });
      this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm)
      const chartQuery1 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_OpenReqByDepartment");
      const chartQuery2 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_EfficiencyOfHiring order by gstibo_id asc");
      const chartQuery3 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_Recruitment order by gstibo_value desc");
      const chartQuery4 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_Turnover");
      const chartQuery5 = this.commonService.executedynamicquery("select * , '' color,'' colorbar from gstibo_dev_Dboard_rec_HiresBySource");
      const chartQuery6 = this.commonService.executedynamicquery("select * from gstibo_dev_Dboard_rec_HireByGrade ");
      const chartQuery7 = this.commonService.executedynamicquery("select * ,'' color from gstibo_dev_Dboard_rec_OfferDecline order by gstibo_item");
      const chartQuery8 = this.commonService.executedynamicquery("select * ,'' color from gtstibo_dev_Dboard_rec_Tiles");

      forkJoin([chartQuery1, chartQuery2, chartQuery3, chartQuery4, chartQuery5, chartQuery6, chartQuery7, chartQuery8]).subscribe((qdata: any[]) => {
        let chData1 = [];
        let chData2 = [];
        let chData3 = [];
        let chData4: any = [];
        let chData5 = [];
        let chData6 = [];
        let chData7 = [];
        let chart1Columns = [];
        let chart3Columns = [];
        let chart5Columns = [];
        let chart6Columns = [];
        chart1Columns = [];// ['Department', 'Percentage'];
        this.commonService.ogLog('qdata : ', ['Department', 'Percentage']);
        // let chSubData = [];
        // chSubData.push('Element');
        // chSubData.push('Density');
        // chSubData.push({ role: "style" });
        //chData1.push(chSubData);
        //"Element", "Density", { role: "style" }
        this.commonService.ogLog('qdata : ', qdata[0]['table'], qdata[5]['table'], qdata[4]['table']);
        chart1Columns = [];
        if ((qdata[0]['table']) && (qdata[0]['table'].length > 0)) {
          chart1Columns.push('dept');
          qdata[0]['table'].forEach((element1: any) => {
            let chSubData1 = [];
            chart1Columns.push(element1.gstibo_dept);
          });
          let chSubData1 = [];
          chSubData1.push('');
          qdata[0]['table'].forEach((element1: any) => {
            let chSubDataa1 = [];
            chSubData1.push(element1.gstibo_value);
          });
          chData1.push(chSubData1);

          // });


          // let chSubData1 = [];
          // chart1Columns.push('Dept','Hours');
          // let deptcnt =qdata[0]['table'].map(p => p.gstibo_dept) ;
          // let i=0;
          // deptcnt.forEach(element1 => {
          //   let chSubData1 = []; 
          //   chSubData1.push(deptcnt[i]);
          //   chSubData1.push(qdata[0]['table'].filter(g=>g.gstibo_dept == deptcnt[i])[0].gstibo_value);
          //   chData1.push(chSubData1);
          //   i=i+1;
          // });

          // chart1Columns=[];
          // chart1Columns.push(deptcnt);

          this.commonService.ogLog('chart1Columns:', chart1Columns);
          this.commonService.ogLog('chData1:', chData1);
          this.commonService.ogLog('data1:', qdata[0]['table']);
        } else {
          chData1 = [];
          let chSubData1 = [];
          chart1Columns = []
          chSubData1.push('0');
          chSubData1.push(0);
          chData1.push(chSubData1);
          // });
          //chData1 = null;
        }
        let colors = ['#deb887', '#d6dac8', '#f1ef99', '#c5ebaa', '#ffefdf', '#d2691e', '#cd853f', '#f0e68c', '#5f9ea0', '#87ceeb'];// ['#525be4', '#9c52fd', '#ef0c51', '#24e4ab', '#ef0c51', '#24e4ab'];
        if (chData1.length > 0) {
          this.chartForm1.patchValue({
            chartType: 'barChart',
            width: '100%',
            height: '21rem',
            data: chData1,
            columnNames: chart1Columns,
            colors: colors,
            legendPosition: 'bottom',
            legend: { position: 'bottom', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
            bar: "70%",//requisition 
            bargroupwidth: '5',
            legendMaxLine: '5',
            chartArea: {
              bottom: 20,
              right: 10,
              left: 10,
              top: 20,
              width: '150px'
            },
            barPercentage: 0.2,
          });
          this.commonService.ogLog('this.chartForm1', this.chartForm1);
          this.commonService.ogLog('this.chartForm1', chData1, chart1Columns);

        }
        if (qdata[1]['table']) {
          this.roundChartEffHiring = qdata[1]['table'];
          let total = 0;

          if ((qdata[1]['table']) && (qdata[1]['table'].length > 0)) {
            qdata[1]['table'].forEach((element2: any) => {
              let chSubData3 = [];
              total += Number(element2.gstibo_value);
              chart3Columns.push(element2.gstibo_Item);
              chSubData3.push(element2.gstibo_Item);
              chSubData3.push(element2.gstibo_value);
              chData3.push(chSubData3);
            });
          }
          else {
            let chSubData3 = [];
            chart3Columns.push('0');
            chSubData3.push('0');
            chSubData3.push('0');
            chData3.push(chSubData3);
          }
          this.commonService.ogLog('chData3', chData3);
          this.totalEHValue = total.toString();
          this.commonService.ogLog('this.roundChartEffHiring', this.roundChartEffHiring)
          this.chartForm3.patchValue({
            chartType: this.dashboardTemplateForm.value.chartBlock2,
            width: '31rem',
            height: '20rem',
            data: chData3,
            columnNames: chart3Columns,
            legendPosition: 'right',
            pieHole: '0.1',
            chartArea: {
              bottom: 0,
              right: 0,
              left: 0,
              top: 20

            }
          });
        }
        if (qdata[2]['table']) {
          this.commonService.ogLog('data3:', qdata[2]['table']);
          this.recruitmentFunnel = qdata[2]['table'];
        }
        if (qdata[3]['table']) {
          qdata[3]['table'].forEach((element1: any) => {
            let chSubData4 = [];
            chSubData4.push(element1.gstibo_year);
            chSubData4.push(element1.gstibo_value1);
            chSubData4.push(element1.gstibo_value1);
            chSubData4.push(element1.gstibo_value1);
            chData4.push(chSubData4);
          });
          this.commonService.ogLog('chData4:', chData4);
        } else {
          chData4 = null;
        }
        this.chartForm4.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock4,
          width: '100%',
          height: '20rem',
          data: chData4,
          columnNames: ['Year', 'Value1', 'Value2', 'Value3']
        });
        this.recuirtmentnewhire = qdata[4]['table'];
        this.commonService.ogLog('qdata[4]:', qdata[4]['table']);
        if ((qdata[4]['table']) && (qdata[4]['table'].length > 0)) {
          for (let i = 0; i < this.recuirtmentnewhire.length; i++) {
            chart5Columns.push({ "name": this.recuirtmentnewhire[i].gstibo_Item, "color": this.recuritmenthirecoloredArray[i] });
          }
          for (let i = 0; i < this.recuirtmentnewhire.length; i++) {
            chData5.push({ "name": this.recuirtmentnewhire[i].gstibo_Item, "value": this.recuirtmentnewhire[i].gstibo_value, "color": this.recuritmenthirbarecoloredArray[i] });//
          }
          qdata[4]['table'].forEach((element1: any) => {
            let chSubData5 = [];
            //chart5Columns.push(element1.gstibo_Item);
            chSubData5.push(element1.gstibo_Item);
            chSubData5.push(element1.gstibo_value);
            chData5.push(chSubData5);
          });
          this.commonService.ogLog('chart5Columns:', chart5Columns);
          this.commonService.ogLog('data5:', qdata[4]['table']);
        } else {
          let chSubData5 = [];
          chart5Columns.push('0');
          chSubData5.push('0');
          chSubData5.push('0');
          chData5.push(chSubData5);
          //chData5 = null;
        }
        this.commonService.ogLog('chData5', chData5);
        this.chartForm5.patchValue({
          chartType: this.dashboardTemplateForm.value.chartBlock5,
          // width: '100%',
          height: '20rem',
          data: chData5,
          columnNames: chart5Columns,
          legendPosition: 'bottom'
        });
        // this.commonService.ogLog('chData5', this.chartForm5.controls.data.value);
        //qdata[5] time to hire bygrades




        ///////////////////////////////////////

        let chSubData6 = [];
        if ((qdata[5]['table']) && (qdata[5]['table'].length > 0)) {
          // chData6.push(['Category','Count','week'])
          chData6 = [];
          chart6Columns = ['Name', 'Days'];
          qdata[5]['table'].forEach((element1: any) => {
            let chSubData6 = [];
            let valueofweek = element1.gstibo_value == null ? 0 : element1.gstibo_value;
            if (valueofweek == 0) {
              element1.gstibo_cnt = 0;
            }
            let countasint: Number = element1.gstibo_cnt;
            chSubData6.push(element1.gstibo_item, valueofweek);

            chData6.push(chSubData6);
          });
          this.commonService.ogLog('chart1Columns:', chart6Columns);
        }
        else {
          chData6 = [];
          let chSubData6 = [];
          chart6Columns = ['Name', 'Days'];
          chSubData6.push('0');
          chSubData6.push('0');
          chData6.push(chSubData6);

        }

        if (chData6.length > 0) {
          this.chartForm6.patchValue({
            chartType: this.dashboardTemplateForm.value.chartBlock1,
            width: '100%',
            height: '18rem',
            data: chData6,
            columnNames: chart6Columns,
            legend: { position: 'left', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
            bars: 'horizontal',
            chartArea: {
              bottom: 40,
              right: 20,
              left: 100,
              top: 20

            },
            hAxis: { title: 'Days' },
            colors: ['#FFB8CD', '#A9FFE6'],
            bargroupwidth: "5%",
            barPercentage: 0.4,
          });
          this.commonService.ogLog('this.chartForm6', this.chartForm6);
        }
        else {
          chData6 = [];
          let chSubData6 = [];
          chart6Columns = ['Name', 'Day', 'Count'];
          chSubData6.push('0');
          chSubData6.push('0');
          chData6.push(chSubData6);

        }




        // chart6 end
        //
        this.DealProgressColoredArray = ["bars", "bars blue", "bars pink", "bars green", "bars violet"];
        if (qdata[6]['table']) {
          this.offerDecline = [];
          this.offerDecline = qdata[6]['table'];
          for (let i = 0; i < this.offerDecline.length; i++) {
            this.offerDecline[i].color = this.DealProgressColoredArray[i];
            // this.offerDecline.push({"gstibo_Item":this.offerDecline[i].gstibo_Item,"gstibo_value":this.recuirtmentnewhire[i].gstibo_value,
            // "color":this.DealProgressColoredArray[i],"gstibo_per":this.offerDecline[i].gstibo_Item});//
          }
          this.commonService.ogLog('chData7:', qdata[6]['table']);
        }
        if (qdata[7]['table']) {
          this.recruirtmenttiles = qdata[7]['table'];
        }
      }, error => {
        console.log('forkjoin error');
      });

    });

    this.commonService.ogLog('this.dashboardTemplateForm:', this.dashboardTemplateForm);

  }
  async loadTemplateTwenty() {
    let accountId = this.commonService.getUserCredentials(KEYS.credential_account_id);
    this.getOutlookCalendarEvents();
    if (this.msAuthService.authenticated) {
      if (this.msAuthService.user) {
        await this.loadMails(this.msAuthService.user)
      } else {
        await this.loadMails(await this.msAuthService.getUser())
      }
    }
    this.commonService.getLoginSessionDetails(accountId).subscribe((data: any) => {
      if (isData(data)) {
        if (isPresent(data['table']))
          this.weeklyNewSession = data['table'][0]['newSession'];
        if (isPresent(data['table1'])) {
          let totalSeconds = data['table1'][0]['avgtimeonsite'];
          this.avgTimeOnSiteWeek = this.sessionTimer.formatTime(totalSeconds * 1000)
        }
        if (isPresent(data['table3']))
          this.bounceRate = data['table3'][0]['bouncerate'];
      }
    })
    this.commonService.getPageView(accountId).subscribe((data: any) => {
      if (isData(data)) {
        if (isPresent(data['table']))
          this.viewPageCount = data['table'][0]['pageviewcount']
      }
    })
  }
  /** End project dropdown in chart */
  navigatePage() {
    this.commonService.ogLog('renetere');

    sessionStorage.setItem('moduleName', KEYS.hr_module);
    const pageDetails = {
      pageId: 264,
      pageName: 'Time Sheet',
      parentMenuId: 190,
      menuId: 202,
      withChildMenues: 0,
      withChildInnerPage: 0,
      isAddMode: false
    }
    this.commonService.ogLog('time SHeet', pageDetails);
    sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
    this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
  }

  navigatePagetoExpenseReport() {
    const pageDetails = {
      pageId: 258,
      pageName: 'Expense Report',
      parentMenuId: 190,
      menuId: 204,
      withChildMenues: 0,
      withChildInnerPage: 0,
      isAddMode: false
    }
    sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
    this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
  }
  navigatePagetoOpertunity() {
    sessionStorage.setItem('moduleName', KEYS.procurment_module);
    const pageDetails = {
      pageId: 388,
      pageName: 'Opportunity',
      parentMenuId: 303,
      menuId: 310,
      withChildMenues: 0,
      withChildInnerPage: 0,
      isAddMode: false
    }
    sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
    this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
  }
  ontimesheetweekchange(e: any) {
    this.timesheetweek = e.target.value;
  }
  ontimeoutweekchange(e: any) {
    this.timeoutweek = e.target.value;
  }
  Redircttocontactpage() {
    this.commonService.setDashbord(false);
    sessionStorage.setItem('moduleName', KEYS.contact_module);
    if (this.ismcf == true) {
      const pageDetails = {
        pageId: 600,
        pageName: 'Contact Basic Details',
        parentMenuId: 446,
        menuId: 412,
        withChildMenues: 0,
        withChildInnerPage: 0,
        isAddMode: false
      }
      sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
      this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
    }
    else {
      const pageDetails = {
        pageId: 409,
        pageName: 'Contact Details',
        parentMenuId: 320,
        menuId: 321,
        withChildMenues: 0,
        withChildInnerPage: 0,
        isAddMode: false
      }

      sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
      this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
    }
  }

  RedircttocontactpageWithFilter(contactType: string) {
    this.commonService.setDashbord(false);
    sessionStorage.setItem('moduleName', KEYS.contact_module);
    const pageDetails = {
      pageId: 409,
      pageName: 'Contact Details',
      parentMenuId: 320,
      menuId: 615,
      withChildMenues: 0,
      withChildInnerPage: 0,
      isAddMode: false,
      contactFilterType: contactType
    }
    sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
    this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
  }

  Redircttoadmissionpage() {
    this.commonService.setDashbord(false);
    sessionStorage.setItem('moduleName', KEYS.admission_module);
    if (this.ismcf == true) {
      const pageDetails = {
        pageId: 564,
        pageName: 'Admission Register',
        parentMenuId: 415,
        menuId: 415,
        withChildMenues: 0,
        withChildInnerPage: 0,
        isAddMode: false
      }
      sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails)!);
      this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
    }

  }
  clickonmetting(url: string) {

  }
  searchmeeting(e: any) {
    this.commonService.ogLog('searchmeeting:', e.target.value);
    this.MeetingList1 = this.MeetingListnew;
    if (e.target.value != '' && e.target.value.length > 1)
      this.MeetingList1 = this.MeetingList1.filter((x: any) => x.Topic.toLowerCase().trim().includes(e.target.value.toLowerCase().trim()));
    else {
      this.MeetingList1 = this.MeetingListnew;
    }

  }
  loadMeetingdetailsnew() {
    this.MeetingList1 = [];
    this.MeetingListnew = [];
    let accountId = this.commonService.getUserCredentials(KEYS.credential_account_id);
    let meetingtype = "Zoom";
    this.commonService.loadMeetingdetails(meetingtype, accountId, 0).subscribe((data: any) => {
      if (isData(data)) {
        const datas = data['table1'];
        this.commonService.ogLog('datas : ', datas);
        try {
          this.MeetingList1 = [];
          datas.forEach((element: any) => {
            //  if (this.datepipe.transform(element.gstibo_meeting_starttime, "hh:mm a") <= this.datepipe.transform(new Date(), "hh:mm a")) {
            this.MeetingList1.push(
              {

                'Topic': element.gstibo_meeting_topic,
                'StartTime': (element.gstibo_meeting_isrecurring == 1) ? this.datepipe.transform(element.gstibo_meeting_starttime, "hh:mm a") : this.datepipe.transform(element.gstibo_meeting_starttime, "MMM d , hh:mm a"),
                'JoinUrl': element.gstibo_meeting_joinurl,
                'MeetingID': element.gstibo_meeting_ID,
                'Hostby': element.hostby

              }
            );
            //}
          });
          this.MeetingListnew = this.MeetingList1;
        } catch (e) { }

        this.commonService.ogLog('meetingdata:', this.MeetingList1);
      } else {
        this.commonService.ogLog('loadManagemeeting No Rows found');
      }

    },
      (error: any) => {
        console.log('get loadmeeting list Error:', error);
      });

    if (this.MeetingList1.length > 0) {

    }
  }
  Zoommeetingclick() {
    this.activemeeting = true;
    //this.activeteams=false;
    this.loadMeetingdetailsnew();
  }
  teamsmeetingclick() {
    this.activemeeting = false;
    //this.activeteams=true;
    this.MeetingList1 = [];
    this.MeetingListnew = [];
    let accountId = this.commonService.getUserCredentials(KEYS.credential_account_id);
    let meetingtype = "teams";
    this.commonService.loadMeetingdetails(meetingtype, accountId, 0).subscribe((data: any) => {
      if (isData(data)) {
        const datas = data['table1'];
        this.commonService.ogLog('datas : ', datas);
        try {
          datas.forEach((element: any) => {
            //  if (this.datepipe.transform(element.gstibo_meeting_starttime, "hh:mm a") <= this.datepipe.transform(new Date(), "hh:mm a")) {
            this.MeetingList1.push(
              {

                'Topic': element.gstibo_meeting_topic,
                'StartTime': (element.gstibo_meeting_isrecurring == 1) ? this.datepipe.transform(element.gstibo_meeting_starttime, "hh:mm a") : this.datepipe.transform(element.gstibo_meeting_starttime, "MMM d , hh:mm a"),
                'JoinUrl': element.gstibo_meeting_joinurl,
                'MeetingID': element.gstibo_meeting_ID,
                'Hostby': element.hostby

              }
            );
            //}
          });
          this.MeetingListnew = this.MeetingList1;
        } catch (e) { }

        this.commonService.ogLog('meetingdata:', this.MeetingList1);
      } else {
        this.commonService.ogLog('loadManagemeeting No Rows found');
      }

    },
      (error: any) => {
        console.log('get loadmeeting list Error:', error);
      });
  }
  vendorDetails() {
    this.vendoradshboardclick();
  }
  vendoradshboardclick() {
    const userdetails = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    // const pageDetails = {
    //   pageId: 506,
    //   pageName: 'Vendor Management Details',
    //   parentMenuId: userdetails.gstibo_vendor_parentmenuId,
    //   pagePrimaryKey: userdetails.gstibo_vendor_id,// 144,// data['table'][0].tbl_gstibo_vendor_management_details_id,
    //   pagePrimaryKeyColumnName: 'tbl_gstibo_vendor_management_details_id',
    //   gridTableName: 'tbl_gstibo_vendor_management_details',
    //   gridId: 408,
    //   gridNavigationType: 1,
    //   isAddMode: false,
    //   isInnerGrid: '0',
    //   parentPageId: 505,
    // }
    const pageDetails = {
      pageId: 408,
      pageName: 'Contact Details',
      parentMenuId: 320,
      pagePrimaryKey: userdetails.gstibo_vendor_id,// 144,// data['table'][0].tbl_gstibo_vendor_management_details_id,
      pagePrimaryKeyColumnName: 'tbl_gstibo_contact_hdr_id',
      gridTableName: 'tbl_gstibo_contact_hdr',
      gridId: 342,
      gridNavigationType: 1,
      isAddMode: false,
      isInnerGrid: '0',
      parentPageId: 409,
    }
    this.commonService.ogLog('pagedata:', pageDetails);
    sessionStorage.setItem("acivemenuId", pageDetails.parentMenuId.toString());
    this.commonService.setParentMenuName('Contacts');
    sessionStorage.setItem('moduleName', 'Contacts');
    sessionStorage.setItem(KEYS.subPageDetails, JSON.stringify(pageDetails));
    this.commonService.setParentTblData$(
      {
        pagePrimaryKey: userdetails.gstibo_vendor_id,//data['table'][0].tbl_gstibo_vendor_management_details_id,
        pagePrimaryKeyColumnName: 'tbl_gstibo_contact_hdr_id'
      });
    this.commonService.setDynamicPageDataForEdit(pageDetails);
    sessionStorage.removeItem(KEYS.vendor_data);
    const mainpageDetail = {
      pageId: 409,
      pageName: 'Contact Details',
      parentMenuId: 320,
      menuId: 321,
      withChildMenues: 0,
      withChildInnerPage: 0,
      isAddMode: false
    }
    sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(mainpageDetail)!);
    sessionStorage.setItem(KEYS.mainpagePKValue, JSON.parse(userdetails.gstibo_vendor_id)!);
    sessionStorage.setItem(KEYS.parentGridPrimaryKey, 'tbl_gstibo_contact_hdr_id');
    const path = RoutePath.userSubPageLayout.replace(':page_name', pageDetails.pageName);// JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)).pageName);
    this.router.navigate([path, pageDetails.pageName]);
  }
  getVendorOpportunityList() {
    this.vendorOpportunityList = [];
    const userdetails = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    this.commonService.getdashboardVendorOpportunityList(userdetails.gstibo_account_email).subscribe((data: any) => {
      if (isPresent(data['table'])) {
        let data1 = data['table']
        this.vendorOpportunityList = data['table'];
        this.commonService.ogLog('Data:', data);
      }
    });
  }
  getvendorDocumentsList() {
    this.vendorDocsList = [];
    const userdetails = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    this.commonService.getdashboardVendorDocsList(userdetails.gstibo_account_email).subscribe((data: any) => {
      if (isPresent(data['table'])) {
        let data1 = data['table']
        this.vendorDocsList = data['table'].filter((g: any) => g.nf_file_name != null);
        this.commonService.ogLog('Data:', this.vendorDocsList);
      }
    });
  }
  viewfiles(filepath: string) {
    this.commonService.ogLog("filepath:", filepath);
    const root = this.commonService.getAppUrl();
    const url = root + filepath;
    this.commonService.ogLog("fullpath:", url);
    window.open(url, '_blank');
  }
  vendoroverview() {
    const userdetails = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    const pageDetails = {
      pageId: 409,
      pageName: 'Contact Details',
      parentMenuId: 320,
      menuId: 321,
      isAddMode: false,
      withChildInnerPage: 0,
      withChildMenues: 0,
      vendorId: userdetails.gstibo_vendor_id,
      vendorfrom: 'overview'
    }
    sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
    this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails), VendorId: userdetails.gstibo_vendor_id } });

  }

  changepassword() {
    const config: ModalOptions = { class: KEYS.modalConfigClass, backdrop: "static", animated: true, }
    this.bsModalRef = this.modalService.show(ChangePasswordComponent, config);
    this.bsModalRef.content.data = {
      title: this.labelChangePassword.title,
      btnConfirm: this.labelChangePassword.btnConfirm,
      btnCancel: this.labelChangePassword.btnCancel
    }
  }
  signOut() {
    
    let accountID = this.commonService.getUserCredentials(KEYS.credential_account_id)
    this.commonService.logoutupdate(accountID).subscribe(data => {
      if (isData(data)) {
      }
    });
    this.fullscreenService.exit();
    this.authService.signOut();
  }
  vendorhelpdesk() {
    const userdetails = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
    const pageDetails = {
      pageId: 268,
      pageName: 'Issue Tracker',
      parentMenuId: 206,
      menuId: 207,
      isAddMode: false,
      withChildInnerPage: 0,
      withChildMenues: 0
    }
    sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
    let parentmenu = 'Help Desk';
    this.commonService.setParentMenuName(parentmenu);
    sessionStorage.setItem('moduleName', parentmenu);

    this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });

  }
  onopportunityfunnelchange(e: any) {
    let quarter = e.target.value;
    this.funnelquarter = quarter;
    this.commonService.ogLog('data funnelquarter: ', this.funnelquarter);
    this.router.navigate([this.routePath.dashboardUser], { queryParams: { funnelquarter: this.funnelquarter, menuid: this.menuId } });

  }
  onWinQuarterChange(e: any) {
    let quarter = e.target.value;
    this.winQuarter = quarter;
    this.commonService.ogLog('data winQuarter: ', this.winQuarter);
    this.router.navigate([this.routePath.dashboardUser], { queryParams: { winQuarter: this.winQuarter, menuid: this.menuId } });
  }

  //#region outlook contact and procumentdashbaord

  async signInOutlook() {
    if (sessionStorage.getItem('outlookSignInLoadingMsgShown') === 'false') {
      this.commonService.setLoadingMessageLoader('Outlook SignIn In Progress...');
      sessionStorage.setItem('outlookSignInLoadingMsgShown', 'true');
    } else {
      this.commonService.setLoadingMessageLoader('');
    }
    if (!this.msAuthService.authenticated)
      await this.msAuthService.signIn();
    this.getOutlookCalendarEvents();
    await this.getoutlook(this.tabPageId);
  }
  async signOutOutlook() {
    const loggedOut = await this.msAuthService.signOutOutlookUser();
    if (loggedOut) {
      this.mails = [];
      this.mainmails = [];
      this.groupmail = [];
      this.calenderEvents = [];
    }
  }
  async getoutlook(page_Id: number) {
    if (sessionStorage.getItem('outlookSignInLoadingMsgShown') === 'false') {
      this.commonService.setLoadingMessageLoader('Outlook SignIn In Progress...');
      sessionStorage.setItem('outlookSignInLoadingMsgShown', 'true');
    } else {
      this.commonService.setLoadingMessageLoader('');
    }
    if (this.msAuthService.authenticated) {
      this.commonService.setLoadingMessageLoader('')
      setTimeout(async () => {
        if (this.msAuthService.user) {
          await this.loadMails(this.msAuthService.user)
        } else {
          await this.loadMails(await this.msAuthService.getUser())
        }
      }, 20);
    }
  }
  async loadMails(msAuthUser: any) {
    this.mailDetails = '';
    this.filtercolumn = '';
    //this.initPageForm();
    if (JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!)?.pageId == 409) {
      this.filtercolumn = sessionStorage.getItem(KEYS.selectedContactEmail);
    } else {
      this.filtercolumn = this.commonService.getMailBoxEmail();
    }
    this.showSearch = (this.filtercolumn == '' ? 'true' : 'false');
    const ianaName = findIana(msAuthUser?.timeZone ?? 'India Standard Time');
    this.currentTimeZone = ianaName.toString().split(",")[0];
    this.noToSkip = this.loadCount * 15;
    if (sessionStorage.getItem('outlookMailLoadingMsgShown') === 'false') {
      this.commonService.setLoadingMessageLoader('Outlook Mail Loading In Progress...');
      sessionStorage.setItem('outlookMailLoadingMsgShown', 'true');
    } else {
      this.commonService.setLoadingMessageLoader('');
    }
    this.mails = await this.graphService.getMailBoxView(msAuthUser?.timeZone ?? 'India Standard Time', this.filtercolumn, '', 'Inbox', this.noToSkip);
    this.commonService.ogLog('This.mails:', this.mails);
    if (this.mails!.length > 0) {
      this.loadMessage(this.mails![0].id);
    } else {
      this.mainmails = [];
      this.groupmail = [];
      this.clearDetail();
    }
    this.commonService.setLoadingMessageLoader('');
    this.setGroupMailDataOutlook();
    this.commonService.clearMailBoxEmail();
  }
  clearDetail() {
    this.mailSubject = "";
    this.mailSender = "";
    this.mailReceiver = "";
    this.mailDate = "";
    this.mailDetailsContent = "";
  }
  convertTimeToLocal(dt: any) {

    let localDate = toZonedTime(dt, this.currentTimeZone);
    let formattedDate = this.datePipe.transform(localDate, 'EEE ' + this.custDateFormat_date + ' HH:mm');
    return formattedDate;
  }
  async loadMessage(message: any) {
    const now = new Date();
    let id = message;
    this.mailDetails = await this.graphService.getMessage(id, this.msAuthService.user!.timeZone);
    //console.log('this.mailDetails', this.mailDetails);
    this.mailDetailsContent = this.mailDetails.body.content.replaceAll(' href="', ' target="_blank" href="');
    this.mailSubject = this.mailDetails.subject;
    this.mailSender = this.mailDetails.sender.emailAddress.name;
    if (this.mailDetails.toRecipients.length > 0)
      this.mailReceiver = this.mailDetails.toRecipients[0].emailAddress.name;
    else
      this.mailReceiver = this.msAuthService.user!.email;
    this.mailDate = this.convertTimeToLocal(this.mailDetails.receivedDateTime);
  }
  setGroupMailDataOutlook() {
    this.mainmails = [];
    this.groupmail = [];
    setTimeout(() => {
      this.mails!.forEach((element: any) => {
        this.mainmails.push(
          {
            'Recevied': element.receivedDateTime,//  this.datePipe.transform(element.receivedDateTime, 'yyyy-MM-dd'),
            'From': element.sender.emailAddress.name,
            'Subject': element.subject,
            'id': element.id,
          });
      });
      this.mainmails = this.mainmails.slice(0, 10);
      if (this.mainmails.length > 0) {
        this.commonService.ogLog('mainmails', this.mainmails);
        const groups = this.mainmails.reduce((groups: any, mail: any) => {
          const date: any = this.ConvertToFormatDate(mail.Recevied.split('T')[0]);
          const recdate = mail.receivedDateTime;
          if (!groups[date]) {
            groups[date] = [];
          }
          groups[date].push(mail);
          return groups;
        }, {});
        const grouparrays = Object.keys(groups).map((date: string, recdate: any) => {
          return {
            date,
            recdate,
            isOpen: true,
            mails: groups[date],
            frommail: this.setarray(groups[date]),
            subject: this.setarraysubject(groups[date])
          }
        });
        this.groupmail = grouparrays;
        //console.log('grouparrays', this.groupmail);
      }
    }, 350);
  }
  ConvertToFormatDate(time: string) {
    let date = new Date(time);
    let diff = ((new Date()).getTime() - date.getTime()) / 1000;
    let daydiff: any = Math.floor(diff / 86400);
    let today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    if (date.getFullYear() == today.getFullYear() && date.getMonth() == today.getMonth() && date.getDate() == today.getDate())
      return 'Today'
    else if (date.getFullYear() == yesterday.getFullYear() && date.getMonth() == yesterday.getMonth() && date.getDate() == yesterday.getDate())
      return 'Yesterday';
    else if (daydiff > 60)
      return 'Older';
    else if (daydiff > 30)
      return 'Last Month';
    else if (daydiff > 21)
      return 'Three Weeks Ago'
    else if (daydiff > 14)
      return 'Two Weeks Ago'
    else if (daydiff >= 7)
      return 'Last Week'
    else if (daydiff < 7)
      return 'Days ago';
    else {
      let datepipe = new DatePipe("en-US");
      let value = datepipe.transform(date, "MMM-dd-yyyy");
      return value;
    }

  }
  setarray(array: any[]) {
    let value: any[] = [];
    array.forEach((element: any) => {
      value.push(element.From);
    });
    return value;
  }
  setarraysubject(array: any[]) {
    let value: any[] = [];
    array.forEach((element: any) => {
      value.push(element.Subject);
    });
    return value;
  }
  async viewemail(): Promise<void> {
    if (this.authenticated == false) {
      await this.msAuthService.signIn();
    }
    if (this.authenticated) {
      const config: ModalOptions = { class: KEYS.modalConfigClassXXL, backdrop: "static" }
      this.modalRef = this.modalService.show(ViewMailboxComponent, config);
    }
  }
  //#endregion
  getAnnounceData() {
    this.commonService.getBulletinInfo('').subscribe((data: any) => {
      if (isData(data)) {
        const lastdate = data['table'][data['table'].length - 1].gstibo_created_date;
        let bulletinData = data['table'].filter((d: any) => d.gstibo_created_date == lastdate);
        this.AnnounceText = bulletinData[0].gstibo_description;
      }
    });
  }
  EditAnnoucements(annoucement: HTMLElement) {
    if (this.buttonlabelAnnouce == 'Edit') {
      this.buttonAnnouce = 'IsEdit';
      this.buttonlabelAnnouce = "Update";
      const ele = this.myannounce.nativeElement;
      ele.scrolTop = ele.scrollHeight;
    }
    else if (this.buttonAnnouce == 'IsEdit') {
      this.commonService.updateBulletDefultAnnouncements(annoucement.innerText).subscribe
        (data => {
          if (isData(data)) {
            this.buttonlabelAnnouce = "Edit";
            this.buttonAnnouce = 'NoEdit';
            this.getAnnounceData();
          }
        });
    }
  }
  getActivityDetails() {
    let accountID = this.commonService.getUserCredentials(KEYS.credential_account_id);
    this.commonService.getActivityData(accountID).subscribe
      ((data: any) => {
        if (isData(data)) {
          this.activityData = data['table'];
        }
      });
  }
  redirecttoTeams(meetingUrl: string) {
    window.open(meetingUrl, '_blank');
  }
  async loadTemplateTwentyThree() {
    this.chartFormRecpipline = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      bar: 'horizontal',
      hAxis: { title: 'Days' },
      legendPosition: 'bottom',
      colors: []
    });
    this.chartFormRecOffer = this.formBuilder.group({
      chartType: null,
      width: '',
      data: [null],
      columnNames: [null],
      height: '',
      colors: []
    });
    let accountId = this.commonService.getUserCredentials(KEYS.credential_account_id);
    this.getOutlookCalendarEvents();
    if (this.msAuthService.authenticated) {
      if (this.msAuthService.user) {
        await this.loadMails(this.msAuthService.user)
      } else {
        await this.loadMails(await this.msAuthService.getUser())
      }
    }
    let accountID = this.commonService.getUserCredentials(KEYS.credential_account_id);
    this.commonService.getActivityDataRecruitment(accountID).subscribe
      ((data: any) => {
        if (isData(data)) {
          this.activityDataRecruitment = data['table'];
        }
      });
    this.resources = [
      { name: 'Full Time (W2)', count: 5 },
      { name: 'Part Time', count: 2 },
      { name: '1099', count: 3 },
      { name: 'Temporary', count: 1 },
      { name: 'Corp 2 Corp', count: 2 },
      { name: 'Temp2Hire', count: 2 }
    ];
    const chartQuery1 = this.commonService.executedynamicquery("select  sum(gstibo_value) as accepted,sum(gstibo_per) as rejected,sum(gstibo_pending) as pending ,'' color from gstibo_dev_Dboard_rec_OfferDecline ");
    const query2 = ` select sum(Convert(int,piphire.gstibo_lead))gstibo_lead,
    sum(Convert(int,piphire.gstibo_applicant))gstibo_applicant,
    sum(Convert(int,piphire.gstibo_screening))gstibo_screening,
    sum(Convert(int,piphire.gstibo_interview))gstibo_interview,
    sum(Convert(int,piphire.gstibo_final))gstibo_final,
    isnull(sum(Convert(int,piphire.gstibo_hired)),0)gstibo_hired,sum(Convert(int,piphire.gstibo_hired))gstibo_offer  from gstibo_Dboard_rec_Pipieline_EfficiencyOfHiring  piphire
     `;
    const chartQuery2 = this.commonService.executedynamicquery(query2);
    this.DealProgressColoredArray = ["bars", "bars blue", "bars pink", "bars green", "bars violet"];
    forkJoin([chartQuery1, chartQuery2]).subscribe((qdata: any) => {
      if (qdata[0]['table']) {
        this.offerDecline = [];
        this.offerDecline = qdata[0]['table'];
        let chData2 = [];
        // for (let i = 0; i < this.offerDecline.length; i++) {
        //   this.offerDecline[i].color = this.DealProgressColoredArray[i];
        chData2.push(['Offer Accepted', this.offerDecline[0].accepted])
        chData2.push(['Declined', this.offerDecline[0].rejected])
        chData2.push(['Pending', this.offerDecline[0].pending])
        // }
        let chartColumns2 = ['Status', 'Count'];
        this.chartFormRecOffer.patchValue({
          chartType: 'donutChart',
          width: '100%',
          height: '16rem',
          data: chData2,
          columnNames: chartColumns2,
          chartclick: false,
          colors: ['#fe8043', '#0088fe', '#00c4a0', '#e20eca', '#c3eb13']
        });
      }
      let chart1Columns = [];
      let chData1 = [];
      if ((qdata[1]['table']) && (qdata[1]['table'].length > 0)) {
        //chart1Columns.push('dept');         
        chart1Columns.push('Lead');
        chart1Columns.push('Requsition');
        chart1Columns.push('Screening');
        chart1Columns.push('Interview');
        // chart1Columns.push('HR Review');
        chart1Columns.push('Mgmt. Approve');
        chart1Columns.push('Contract & Offer');
        let chSubData1 = [];
        //chSubData1.push(0);

        chSubData1.push(qdata[1]['table'][0].gstibo_lead);
        chSubData1.push(qdata[1]['table'][0].gstibo_applicant);
        chSubData1.push(qdata[1]['table'][0].gstibo_screening);
        chSubData1.push(qdata[1]['table'][0].gstibo_interview);
        chSubData1.push(qdata[1]['table'][0].gstibo_final);
        chSubData1.push(qdata[1]['table'][0].gstibo_hired);

        chData1.push(chSubData1);
      } else {
        chData1 = [];
        let chSubData1 = [];
        chart1Columns = []
        chSubData1.push('0');
        chSubData1.push(0);
        chData1.push(chSubData1);
        // });
        //chData1 = null;
      }
      let colors = ['#f15282', '#748fb0', '#66b777', '#ca5ea0', '#d77648', '#93cae6', '#7a70ba', '#f0e68c', '#5f9ea0', '#87ceeb'];// ['#525be4', '#9c52fd', '#ef0c51', '#24e4ab', '#ef0c51', '#24e4ab'];
      if (chData1.length > 0) {
        this.chartFormRecpipline.patchValue({
          chartType: 'barChart',
          width: '100%',
          height: '18rem',
          data: chData1,
          columnNames: chart1Columns,
          colors: colors,
          legendPosition: 'bottom',
          legend: { position: 'bottom', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
          bar: "horizontal",//requisition 
          chartArea: {
            bottom: 40,
            right: 10,
            left: 10,
            top: 20,
            width: '150px'
          },
          barPercentage: 0.2,
        });
        // this.commonService.ogLog('offerDecline:', qdata[0]['table']);
      }
    })
  }
}


